(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.MessageFormat = factory());
}(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    return function () {
      var Super = _getPrototypeOf(Derived),
          result;

      if (_isNativeReflectConstruct()) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _createForOfIteratorHelper(o) {
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
      if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) {
        var i = 0;

        var F = function () {};

        return {
          s: F,
          n: function () {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function (e) {
            throw e;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var it,
        normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function () {
        it = o[Symbol.iterator]();
      },
      n: function () {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function (e) {
        didErr = true;
        err = e;
      },
      f: function () {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  /**
   * Parent class for errors.
   *
   * @remarks
   * Errors with `type: "warning"` do not necessarily indicate that the parser
   * encountered an error. In addition to a human-friendly `message`, may also
   * includes the `token` at which the error was encountered.
   *
   * @public
   */
  var DateFormatError = /*#__PURE__*/function (_Error) {
    _inherits(DateFormatError, _Error);

    var _super = _createSuper(DateFormatError);

    /** @internal */
    function DateFormatError(msg, token, type) {
      var _this;

      _classCallCheck(this, DateFormatError);

      _this = _super.call(this, msg);
      _this.token = token;
      _this.type = type || 'error';
      return _this;
    }

    return DateFormatError;
  }( /*#__PURE__*/_wrapNativeSuper(Error));

  var alpha = function alpha(width) {
    return width < 4 ? 'short' : width === 4 ? 'long' : 'narrow';
  };

  var numeric = function numeric(width) {
    return width % 2 === 0 ? '2-digit' : 'numeric';
  };

  function yearOptions(token, onError) {
    switch (token.char) {
      case 'y':
        return {
          year: numeric(token.width)
        };

      case 'r':
        return {
          calendar: 'gregory',
          year: 'numeric'
        };

      case 'u':
      case 'U':
      case 'Y':
      default:
        onError("".concat(token.desc, " is not supported; falling back to year:numeric"), DateFormatError.WARNING);
        return {
          year: 'numeric'
        };
    }
  }

  function monthStyle(token, onError) {
    switch (token.width) {
      case 1:
        return 'numeric';

      case 2:
        return '2-digit';

      case 3:
        return 'short';

      case 4:
        return 'long';

      case 5:
        return 'narrow';

      default:
        onError("".concat(token.desc, " is not supported with width ").concat(token.width));
        return undefined;
    }
  }

  function dayStyle(token, onError) {
    var char = token.char,
        desc = token.desc,
        width = token.width;
    if (char === 'd') return numeric(width);else {
      onError("".concat(desc, " is not supported"));
      return undefined;
    }
  }

  function weekdayStyle(token, onError) {
    var char = token.char,
        desc = token.desc,
        width = token.width;

    if ((char === 'c' || char === 'e') && width < 3) {
      // ignoring stand-alone-ness
      var msg = "Numeric value is not supported for ".concat(desc, "; falling back to weekday:short");
      onError(msg, DateFormatError.WARNING);
    } // merging narrow styles


    return alpha(width);
  }

  function hourOptions(token) {
    var hour = numeric(token.width);
    var hourCycle;

    switch (token.char) {
      case 'h':
        hourCycle = 'h12';
        break;

      case 'H':
        hourCycle = 'h23';
        break;

      case 'k':
        hourCycle = 'h24';
        break;

      case 'K':
        hourCycle = 'h11';
        break;
    }

    return hourCycle ? {
      hour: hour,
      hourCycle: hourCycle
    } : {
      hour: hour
    };
  }

  function timeZoneNameStyle(token, onError) {
    // so much fallback behaviour here
    var char = token.char,
        desc = token.desc,
        width = token.width;

    switch (char) {
      case 'v':
      case 'z':
        return width === 4 ? 'long' : 'short';

      case 'V':
        if (width === 4) return 'long';
        onError("".concat(desc, " is not supported with width ").concat(width));
        return undefined;

      case 'X':
        onError("".concat(desc, " is not supported"));
        return undefined;
    }

    return 'short';
  }

  function compileOptions(token, onError) {
    switch (token.field) {
      case 'era':
        return {
          era: alpha(token.width)
        };

      case 'year':
        return yearOptions(token, onError);

      case 'month':
        return {
          month: monthStyle(token, onError)
        };

      case 'day':
        return {
          day: dayStyle(token, onError)
        };

      case 'weekday':
        return {
          weekday: weekdayStyle(token, onError)
        };

      case 'period':
        return undefined;

      case 'hour':
        return hourOptions(token);

      case 'min':
        return {
          minute: numeric(token.width)
        };

      case 'sec':
        return {
          second: numeric(token.width)
        };

      case 'tz':
        return {
          timeZoneName: timeZoneNameStyle(token, onError)
        };

      case 'quarter':
      case 'week':
      case 'sec-frac':
      case 'ms':
        onError("".concat(token.desc, " is not supported"));
    }

    return undefined;
  }

  function getDateFormatOptions(tokens) {
    var onError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (error) {
      throw error;
    };
    var options = {};
    var fields = [];

    var _iterator = _createForOfIteratorHelper(tokens),
        _step;

    try {
      var _loop = function _loop() {
        var token = _step.value;
        var error = token.error,
            field = token.field,
            str = token.str;

        if (error) {
          var dte = new DateFormatError(error.message, token);
          dte.stack = error.stack;
          onError(dte);
        }

        if (str) {
          var msg = "Ignoring string part: ".concat(str);
          onError(new DateFormatError(msg, token, DateFormatError.WARNING));
        }

        if (field) {
          if (fields.indexOf(field) === -1) fields.push(field);else onError(new DateFormatError("Duplicate ".concat(field, " token"), token));
        }

        var opt = compileOptions(token, function (msg, isWarning) {
          return onError(new DateFormatError(msg, token, isWarning));
        });

        if (opt) {
          var keys = Object.keys(opt);

          for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
            var key = _keys[_i];
            options[key] = opt[key];
          }
        }
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return options;
  }

  var fields = {
    G: {
      field: 'era',
      desc: 'Era'
    },
    y: {
      field: 'year',
      desc: 'Year'
    },
    Y: {
      field: 'year',
      desc: 'Year of "Week of Year"'
    },
    u: {
      field: 'year',
      desc: 'Extended year'
    },
    U: {
      field: 'year',
      desc: 'Cyclic year name'
    },
    r: {
      field: 'year',
      desc: 'Related Gregorian year'
    },
    Q: {
      field: 'quarter',
      desc: 'Quarter'
    },
    q: {
      field: 'quarter',
      desc: 'Stand-alone quarter'
    },
    M: {
      field: 'month',
      desc: 'Month in year'
    },
    L: {
      field: 'month',
      desc: 'Stand-alone month in year'
    },
    w: {
      field: 'week',
      desc: 'Week of year'
    },
    W: {
      field: 'week',
      desc: 'Week of month'
    },
    d: {
      field: 'day',
      desc: 'Day in month'
    },
    D: {
      field: 'day',
      desc: 'Day of year'
    },
    F: {
      field: 'day',
      desc: 'Day of week in month'
    },
    g: {
      field: 'day',
      desc: 'Modified julian day'
    },
    E: {
      field: 'weekday',
      desc: 'Day of week'
    },
    e: {
      field: 'weekday',
      desc: 'Local day of week'
    },
    c: {
      field: 'weekday',
      desc: 'Stand-alone local day of week'
    },
    a: {
      field: 'period',
      desc: 'AM/PM marker'
    },
    b: {
      field: 'period',
      desc: 'AM/PM/noon/midnight marker'
    },
    B: {
      field: 'period',
      desc: 'Flexible day period'
    },
    h: {
      field: 'hour',
      desc: 'Hour in AM/PM (1~12)'
    },
    H: {
      field: 'hour',
      desc: 'Hour in day (0~23)'
    },
    k: {
      field: 'hour',
      desc: 'Hour in day (1~24)'
    },
    K: {
      field: 'hour',
      desc: 'Hour in AM/PM (0~11)'
    },
    j: {
      field: 'hour',
      desc: 'Hour in preferred cycle'
    },
    J: {
      field: 'hour',
      desc: 'Hour in preferred cycle without marker'
    },
    C: {
      field: 'hour',
      desc: 'Hour in preferred cycle with flexible marker'
    },
    m: {
      field: 'min',
      desc: 'Minute in hour'
    },
    s: {
      field: 'sec',
      desc: 'Second in minute'
    },
    S: {
      field: 'sec-frac',
      desc: 'Fractional second'
    },
    A: {
      field: 'ms',
      desc: 'Milliseconds in day'
    },
    z: {
      field: 'tz',
      desc: 'Time Zone: specific non-location'
    },
    Z: {
      field: 'tz',
      desc: 'Time Zone'
    },
    O: {
      field: 'tz',
      desc: 'Time Zone: localized'
    },
    v: {
      field: 'tz',
      desc: 'Time Zone: generic non-location'
    },
    V: {
      field: 'tz',
      desc: 'Time Zone: ID'
    },
    X: {
      field: 'tz',
      desc: 'Time Zone: ISO8601 with Z'
    },
    x: {
      field: 'tz',
      desc: 'Time Zone: ISO8601'
    }
  };

  var isLetter = function isLetter(char) {
    return char >= 'A' && char <= 'Z' || char >= 'a' && char <= 'z';
  };

  function readFieldToken(src, pos) {
    var char = src[pos];
    var width = 1;

    while (src[++pos] === char) {
      ++width;
    }

    var field = fields[char];

    if (!field) {
      var msg = "The letter ".concat(char, " is not a valid field identifier");
      return {
        char: char,
        error: new Error(msg),
        width: width
      };
    }

    return {
      char: char,
      field: field.field,
      desc: field.desc,
      width: width
    };
  }

  function readQuotedToken(src, pos) {
    var str = src[++pos];
    var width = 2;
    if (str === "'") return {
      char: "'",
      str: str,
      width: width
    };

    while (true) {
      var next = src[++pos];
      ++width;

      if (next === undefined) {
        var msg = "Unterminated quoted literal in pattern: ".concat(str || src);
        return {
          char: "'",
          error: new Error(msg),
          str: str,
          width: width
        };
      } else if (next === "'") {
        if (src[++pos] !== "'") return {
          char: "'",
          str: str,
          width: width
        };else ++width;
      }

      str += next;
    }
  }

  function readToken(src, pos) {
    var char = src[pos];
    if (!char) return null;
    if (isLetter(char)) return readFieldToken(src, pos);
    if (char === "'") return readQuotedToken(src, pos);
    var str = char;
    var width = 1;

    while (true) {
      var next = src[++pos];
      if (!next || isLetter(next) || next === "'") return {
        char: char,
        str: str,
        width: width
      };
      str += next;
      width += 1;
    }
  }
  /**
   * Parse an {@link http://userguide.icu-project.org/formatparse/datetime | ICU
   * DateFormat skeleton} string into a {@link DateToken} array.
   *
   * @remarks
   * Errors will not be thrown, but if encountered are included as the relevant
   * token's `error` value.
   *
   * @public
   * @param src - The skeleton string
   *
   * @example
   * ```js
   * import { parseDateTokens } from 'messageformat-date-skeleton'
   *
   * parseDateTokens('GrMMMdd', console.error)
   * // [
   * //   { char: 'G', field: 'era', desc: 'Era', width: 1 },
   * //   { char: 'r', field: 'year', desc: 'Related Gregorian year', width: 1 },
   * //   { char: 'M', field: 'month', desc: 'Month in year', width: 3 },
   * //   { char: 'd', field: 'day', desc: 'Day in month', width: 2 }
   * // ]
   * ```
   */


  function parseDateTokens(src) {
    var tokens = [];
    var pos = 0;

    while (true) {
      var token = readToken(src, pos);
      if (!token) return tokens;
      tokens.push(token);
      pos += token.width;
    }
  }

  /**
   * Returns a date formatter function for the given locales and date skeleton
   *
   * @remarks
   * Uses `Intl.DateTimeFormat` internally.
   *
   * @public
   * @param locales - One or more valid BCP 47 language tags, e.g. `fr` or `en-CA`
   * @param tokens - An ICU DateFormat skeleton string, or an array or parsed
   *   `DateToken` tokens
   * @param onError - If defined, will be called separately for each encountered
   *   parsing error and unsupported feature.
   * @example
   * ```js
   * import { getDateFormatter } from 'messageformat-date-skeleton'
   *
   * // 2006 Jan 2, 15:04:05.789 in local time
   * const date = new Date(2006, 0, 2, 15, 4, 5, 789)
   *
   * let fmt = getDateFormatter('en-CA', 'GrMMMdd', console.error)
   * fmt(date) // 'Jan. 02, 2006 AD'
   *
   * fmt = getDateFormatter('en-CA', 'hamszzzz', console.error)
   * fmt(date) // '3:04:05 p.m. Newfoundland Daylight Time'
   * ```
   */

  function getDateFormatter(locales, tokens, onError) {
    if (typeof tokens === 'string') tokens = parseDateTokens(tokens);
    var opt = getDateFormatOptions(tokens, onError);
    var dtf = new Intl.DateTimeFormat(locales, opt);
    return function (date) {
      return dtf.format(date);
    };
  }
  /**
   * Returns a string of JavaScript source that evaluates to a date formatter
   * function with the same `(date: Date | number) => string` signature as the
   * function returned by {@link getDateFormatter}.
   *
   * @remarks
   * The returned function will memoize an `Intl.DateTimeFormat` instance.
   *
   * @public
   * @param locales - One or more valid BCP 47 language tags, e.g. `fr` or `en-CA`
   * @param tokens - An ICU DateFormat skeleton string, or an array or parsed
   *   `DateToken` tokens
   * @param onError - If defined, will be called separately for each encountered
   *   parsing error and unsupported feature.
   * @example
   * ```js
   * import { getDateFormatterSource } from 'messageformat-date-skeleton'
   *
   * getDateFormatterSource('en-CA', 'GrMMMdd', console.error)
   * // '(function() {\n' +
   * // '  var opt = {"era":"short","calendar":"gregory","year":"numeric",' +
   * //      '"month":"short","day":"2-digit"};\n' +
   * // '  var dtf = new Intl.DateTimeFormat("en-CA", opt);\n' +
   * // '  return function(value) { return dtf.format(value); }\n' +
   * // '})()'
   *
   * const src = getDateFormatterSource('en-CA', 'hamszzzz', console.error)
   * // '(function() {\n' +
   * // '  var opt = {"hour":"numeric","hourCycle":"h12","minute":"numeric",' +
   * //      '"second":"numeric","timeZoneName":"long"};\n' +
   * // '  var dtf = new Intl.DateTimeFormat("en-CA", opt);\n' +
   * // '  return function(value) { return dtf.format(value); }\n' +
   * // '})()'
   *
   * const fmt = new Function(`return ${src}`)()
   * const date = new Date(2006, 0, 2, 15, 4, 5, 789)
   * fmt(date) // '3:04:05 p.m. Newfoundland Daylight Time'
   * ```
   */

  function getDateFormatterSource(locales, tokens, onError) {
    if (typeof tokens === 'string') tokens = parseDateTokens(tokens);
    var opt = getDateFormatOptions(tokens, onError);
    var lines = ["(function() {", "var opt = ".concat(JSON.stringify(opt), ";"), "var dtf = new Intl.DateTimeFormat(".concat(JSON.stringify(locales), ", opt);"), "return function(value) { return dtf.format(value); }"];
    return lines.join('\n  ') + '\n})()';
  }

  /**
   * Base class for errors. In addition to a `code` and a human-friendly
   * `message`, may also includes the token `stem` as well as other fields.
   *
   * @public
   */
  var NumberFormatError = /*#__PURE__*/function (_Error) {
    _inherits(NumberFormatError, _Error);

    var _super = _createSuper(NumberFormatError);

    /** @internal */
    function NumberFormatError(code, msg) {
      var _this;

      _classCallCheck(this, NumberFormatError);

      _this = _super.call(this, msg);
      _this.code = code;
      return _this;
    }

    return NumberFormatError;
  }( /*#__PURE__*/_wrapNativeSuper(Error));
  /** @internal */

  var BadOptionError = /*#__PURE__*/function (_NumberFormatError) {
    _inherits(BadOptionError, _NumberFormatError);

    var _super2 = _createSuper(BadOptionError);

    function BadOptionError(stem, opt) {
      var _this2;

      _classCallCheck(this, BadOptionError);

      _this2 = _super2.call(this, 'BAD_OPTION', "Unknown ".concat(stem, " option: ").concat(opt));
      _this2.stem = stem;
      _this2.option = opt;
      return _this2;
    }

    return BadOptionError;
  }(NumberFormatError);
  /** @internal */

  var BadStemError = /*#__PURE__*/function (_NumberFormatError2) {
    _inherits(BadStemError, _NumberFormatError2);

    var _super3 = _createSuper(BadStemError);

    function BadStemError(stem) {
      var _this3;

      _classCallCheck(this, BadStemError);

      _this3 = _super3.call(this, 'BAD_STEM', "Unknown stem: ".concat(stem));
      _this3.stem = stem;
      return _this3;
    }

    return BadStemError;
  }(NumberFormatError);
  /** @internal */

  var MaskedValueError = /*#__PURE__*/function (_NumberFormatError3) {
    _inherits(MaskedValueError, _NumberFormatError3);

    var _super4 = _createSuper(MaskedValueError);

    function MaskedValueError(type, prev) {
      var _this4;

      _classCallCheck(this, MaskedValueError);

      _this4 = _super4.call(this, 'MASKED_VALUE', "Value for ".concat(type, " is set multiple times"));
      _this4.type = type;
      _this4.prev = prev;
      return _this4;
    }

    return MaskedValueError;
  }(NumberFormatError);
  /** @internal */

  var MissingOptionError = /*#__PURE__*/function (_NumberFormatError4) {
    _inherits(MissingOptionError, _NumberFormatError4);

    var _super5 = _createSuper(MissingOptionError);

    function MissingOptionError(stem) {
      var _this5;

      _classCallCheck(this, MissingOptionError);

      _this5 = _super5.call(this, 'MISSING_OPTION', "Required option missing for ".concat(stem));
      _this5.stem = stem;
      return _this5;
    }

    return MissingOptionError;
  }(NumberFormatError);
  /** @internal */

  var PatternError = /*#__PURE__*/function (_NumberFormatError5) {
    _inherits(PatternError, _NumberFormatError5);

    var _super6 = _createSuper(PatternError);

    function PatternError(char, msg) {
      var _this6;

      _classCallCheck(this, PatternError);

      _this6 = _super6.call(this, 'BAD_PATTERN', msg);
      _this6.char = char;
      return _this6;
    }

    return PatternError;
  }(NumberFormatError);
  /** @internal */

  var TooManyOptionsError = /*#__PURE__*/function (_NumberFormatError6) {
    _inherits(TooManyOptionsError, _NumberFormatError6);

    var _super7 = _createSuper(TooManyOptionsError);

    function TooManyOptionsError(stem, options, maxOpt) {
      var _this7;

      _classCallCheck(this, TooManyOptionsError);

      var maxOptStr = maxOpt > 1 ? "".concat(maxOpt, " options") : 'one option';
      _this7 = _super7.call(this, 'TOO_MANY_OPTIONS', "Token ".concat(stem, " only supports ").concat(maxOptStr, " (got ").concat(options.length, ")"));
      _this7.stem = stem;
      _this7.options = options;
      return _this7;
    }

    return TooManyOptionsError;
  }(NumberFormatError);
  /** @internal */

  var UnsupportedError = /*#__PURE__*/function (_NumberFormatError7) {
    _inherits(UnsupportedError, _NumberFormatError7);

    var _super8 = _createSuper(UnsupportedError);

    function UnsupportedError(stem, source) {
      var _this8;

      _classCallCheck(this, UnsupportedError);

      _this8 = _super8.call(this, 'UNSUPPORTED', "The stem ".concat(stem, " is not supported"));
      _this8.stem = stem;

      if (source) {
        _this8.message += " with value ".concat(source);
        _this8.source = source;
      }

      return _this8;
    }

    return UnsupportedError;
  }(NumberFormatError);

  /**
   * Add
   * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#Locale_identification_and_negotiation | numbering-system tags}
   * to locale identifiers
   *
   * @internal
   */
  function getNumberFormatLocales(locales, _ref) {
    var numberingSystem = _ref.numberingSystem;
    if (!Array.isArray(locales)) locales = [locales];
    return numberingSystem ? locales.map(function (lc) {
      var ext = lc.indexOf('-u-') === -1 ? 'u-nu' : 'nu';
      return "".concat(lc, "-").concat(ext, "-").concat(numberingSystem);
    }).concat(locales) : locales;
  }

  // from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
  function round(x, precision) {
    var y = +x + precision / 2;
    return y - y % +precision;
  }

  function getNumberFormatMultiplier(_ref) {
    var scale = _ref.scale,
        unit = _ref.unit;
    var mult = typeof scale === 'number' && scale >= 0 ? scale : 1;
    if (unit && unit.style === 'percent') mult *= 0.01;
    return mult;
  }
  /**
   * Determine a modifier for the input value to account for any `scale`,
   * `percent`, and `precision-increment` tokens in the skeleton.
   *
   * @internal
   * @remarks
   * With ICU NumberFormatter, the `percent` skeleton would style `25` as "25%".
   * To achieve the same with `Intl.NumberFormat`, the input value must be `0.25`.
   */


  function getNumberFormatModifier(skeleton) {
    var mult = getNumberFormatMultiplier(skeleton);
    var precision = skeleton.precision;

    if (precision && precision.style === 'precision-increment') {
      return function (n) {
        return round(n, precision.increment) * mult;
      };
    } else {
      return function (n) {
        return n * mult;
      };
    }
  }
  /**
   * Returns a string of JavaScript source that evaluates to a modifier for the
   * input value to account for any `scale`, `percent`, and `precision-increment`
   * tokens in the skeleton.
   *
   * @internal
   * @remarks
   * With ICU NumberFormatter, the `percent` skeleton would style `25` as "25%".
   * To achieve the same with `Intl.NumberFormat`, the input value must be `0.25`.
   */

  function getNumberFormatModifierSource(skeleton) {
    var mult = getNumberFormatMultiplier(skeleton);
    var precision = skeleton.precision;

    if (precision && precision.style === 'precision-increment') {
      // see round() above for source
      var setX = "+n + ".concat(precision.increment / 2);
      var res = "x - (x % +".concat(precision.increment, ")");
      if (mult !== 1) res = "(".concat(res, ") * ").concat(mult);
      return "function(n) { var x = ".concat(setX, "; return ").concat(res, "; }");
    }

    return mult !== 1 ? "function(n) { return n * ".concat(mult, "; }") : null;
  }

  /**
   * Given an input ICU NumberFormatter skeleton, does its best to construct a
   * corresponding `Intl.NumberFormat` options structure.
   *
   * @remarks
   * In addition to standard `Intl.NumberFormat` options, some features make use
   * of the {@link https://github.com/tc39/proposal-unified-intl-numberformat |
   * Unified API Proposal}, which has limited support.
   *
   * @internal
   * @param onUnsupported - If defined, called when encountering unsupported (but
   *   valid) tokens, such as `decimal-always` or `permille`. The error `source`
   *   may specify the source of an unsupported option.
   *
   * @example
   * ```js
   * import {
   *   getNumberFormatOptions,
   *   parseNumberSkeleton
   * } from 'messageformat-number-skeleton'
   *
   * const src = 'currency/CAD unit-width-narrow'
   * const skeleton = parseNumberSkeleton(src, console.error)
   * // {
   * //   unit: { style: 'currency', currency: 'CAD' },
   * //   unitWidth: 'unit-width-narrow'
   * // }
   *
   * getNumberFormatOptions(skeleton, console.error)
   * // {
   * //   style: 'currency',
   * //   currency: 'CAD',
   * //   currencyDisplay: 'narrowSymbol',
   * //   unitDisplay: 'narrow'
   * // }
   *
   * const sk2 = parseNumberSkeleton('group-min2')
   * // { group: 'group-min2' }
   *
   * getNumberFormatOptions(sk2, console.error)
   * // Error: The stem group-min2 is not supported
   * //   at UnsupportedError.NumberFormatError ... {
   * //     code: 'UNSUPPORTED',
   * //     stem: 'group-min2'
   * //   }
   * // {}
   * ```
   */

  function getNumberFormatOptions(skeleton, onUnsupported) {
    var decimal = skeleton.decimal,
        group = skeleton.group,
        integerWidth = skeleton.integerWidth,
        notation = skeleton.notation,
        precision = skeleton.precision,
        roundingMode = skeleton.roundingMode,
        sign = skeleton.sign,
        unit = skeleton.unit,
        unitPer = skeleton.unitPer,
        unitWidth = skeleton.unitWidth;

    var fail = function fail(stem, source) {
      if (onUnsupported) onUnsupported(new UnsupportedError(stem, source));
    };

    var opt = {};

    if (unit) {
      switch (unit.style) {
        case 'base-unit':
          opt.style = 'decimal';
          break;

        case 'currency':
          opt.style = 'currency';
          opt.currency = unit.currency;
          break;

        case 'measure-unit':
          opt.style = 'unit';
          opt.unit = unit.unit.replace(/.*-/, '');
          if (unitPer) opt.unit += '-per-' + unitPer.replace(/.*-/, '');
          break;

        case 'percent':
          opt.style = 'percent';
          break;

        case 'permille':
          fail('permille');
          break;
      }
    }

    switch (unitWidth) {
      case 'unit-width-full-name':
        opt.currencyDisplay = 'name';
        opt.unitDisplay = 'long';
        break;

      case 'unit-width-hidden':
        fail(unitWidth);
        break;

      case 'unit-width-iso-code':
        opt.currencyDisplay = 'code';
        break;

      case 'unit-width-narrow':
        opt.currencyDisplay = 'narrowSymbol';
        opt.unitDisplay = 'narrow';
        break;

      case 'unit-width-short':
        opt.currencyDisplay = 'symbol';
        opt.unitDisplay = 'short';
        break;
    }

    switch (group) {
      case 'group-off':
        opt.useGrouping = false;
        break;

      case 'group-auto':
        opt.useGrouping = true;
        break;

      case 'group-min2':
      case 'group-on-aligned':
      case 'group-thousands':
        fail(group);
        opt.useGrouping = true;
        break;
    }

    if (precision) {
      switch (precision.style) {
        case 'precision-fraction':
          {
            var minF = precision.minFraction,
                maxF = precision.maxFraction,
                minS = precision.minSignificant,
                maxS = precision.maxSignificant,
                source = precision.source;

            if (typeof minF === 'number') {
              opt.minimumFractionDigits = minF;
              if (typeof minS === 'number') fail('precision-fraction', source);
            }

            if (typeof maxF === 'number') opt.maximumFractionDigits = maxF;
            if (typeof minS === 'number') opt.minimumSignificantDigits = minS;
            if (typeof maxS === 'number') opt.maximumSignificantDigits = maxS;
            break;
          }

        case 'precision-integer':
          opt.maximumFractionDigits = 0;
          break;

        case 'precision-unlimited':
          opt.maximumFractionDigits = 20;
          break;

        case 'precision-increment':
        case 'precision-currency-standard':
          break;

        case 'precision-currency-cash':
          fail(precision.style);
          break;
      }
    }

    if (notation) {
      switch (notation.style) {
        case 'compact-short':
          opt.notation = 'compact';
          opt.compactDisplay = 'short';
          break;

        case 'compact-long':
          opt.notation = 'compact';
          opt.compactDisplay = 'long';
          break;

        case 'notation-simple':
          opt.notation = 'standard';
          break;

        case 'scientific':
        case 'engineering':
          {
            var expDigits = notation.expDigits,
                expSign = notation.expSign,
                _source = notation.source,
                style = notation.style;
            opt.notation = style;
            if (expDigits && expDigits > 1 || expSign && expSign !== 'sign-auto') fail(style, _source);
            break;
          }
      }
    }

    if (integerWidth) {
      var min = integerWidth.min,
          max = integerWidth.max,
          _source2 = integerWidth.source;
      if (min > 0) opt.minimumIntegerDigits = min;

      if (Number(max) > 0) {
        var hasExp = opt.notation === 'engineering' || opt.notation === 'scientific';
        if (max === 3 && hasExp) opt.notation = 'engineering';else fail('integer-width', _source2);
      }
    }

    switch (sign) {
      case 'sign-auto':
        opt.signDisplay = 'auto';
        break;

      case 'sign-always':
        opt.signDisplay = 'always';
        break;

      case 'sign-except-zero':
        opt.signDisplay = 'exceptZero';
        break;

      case 'sign-never':
        opt.signDisplay = 'never';
        break;

      case 'sign-accounting':
        opt.currencySign = 'accounting';
        break;

      case 'sign-accounting-always':
        opt.currencySign = 'accounting';
        opt.signDisplay = 'always';
        break;

      case 'sign-accounting-except-zero':
        opt.currencySign = 'accounting';
        opt.signDisplay = 'exceptZero';
        break;
    }

    if (decimal === 'decimal-always') fail(decimal);
    if (roundingMode) fail(roundingMode);
    return opt;
  }

  function parseAffixToken(src, pos, onError) {
    var char = src[pos];

    switch (char) {
      case '%':
        return {
          char: '%',
          style: 'percent',
          width: 1
        };

      case '‰':
        return {
          char: '%',
          style: 'permille',
          width: 1
        };

      case '¤':
        {
          var width = 1;

          while (src[++pos] === '¤') {
            ++width;
          }

          switch (width) {
            case 1:
              return {
                char: char,
                currency: 'default',
                width: width
              };

            case 2:
              return {
                char: char,
                currency: 'iso-code',
                width: width
              };

            case 3:
              return {
                char: char,
                currency: 'full-name',
                width: width
              };

            case 5:
              return {
                char: char,
                currency: 'narrow',
                width: width
              };

            default:
              {
                var msg = "Invalid number (".concat(width, ") of \xA4 chars in pattern");
                onError(new PatternError('¤', msg));
                return null;
              }
          }
        }

      case '*':
        {
          var pad = src[pos + 1];
          if (pad) return {
            char: char,
            pad: pad,
            width: 2
          };
          break;
        }

      case '+':
      case '-':
        return {
          char: char,
          width: 1
        };

      case "'":
        {
          var str = src[++pos];
          var _width = 2;
          if (str === "'") return {
            char: char,
            str: str,
            width: _width
          };

          while (true) {
            var next = src[++pos];
            ++_width;

            if (next === undefined) {
              var _msg = "Unterminated quoted literal in pattern: ".concat(str);

              onError(new PatternError("'", _msg));
              return {
                char: char,
                str: str,
                width: _width
              };
            } else if (next === "'") {
              if (src[++pos] !== "'") return {
                char: char,
                str: str,
                width: _width
              };else ++_width;
            }

            str += next;
          }
        }
    }

    return null;
  }

  var isDigit = function isDigit(char) {
    return char >= '0' && char <= '9';
  };

  function parseNumberToken(src, pos) {
    var char = src[pos];

    if (isDigit(char)) {
      var digits = char;

      while (true) {
        var next = src[++pos];
        if (isDigit(next)) digits += next;else return {
          char: '0',
          digits: digits,
          width: digits.length
        };
      }
    }

    switch (char) {
      case '#':
        {
          var width = 1;

          while (src[++pos] === '#') {
            ++width;
          }

          return {
            char: char,
            width: width
          };
        }

      case '@':
        {
          var min = 1;

          while (src[++pos] === '@') {
            ++min;
          }

          var _width = min;
          pos -= 1;

          while (src[++pos] === '#') {
            ++_width;
          }

          return {
            char: char,
            min: min,
            width: _width
          };
        }

      case 'E':
        {
          var plus = src[pos + 1] === '+';
          if (plus) ++pos;
          var expDigits = 0;

          while (src[++pos] === '0') {
            ++expDigits;
          }

          var _width2 = (plus ? 2 : 1) + expDigits;

          if (expDigits) return {
            char: char,
            expDigits: expDigits,
            plus: plus,
            width: _width2
          };else break;
        }

      case '.':
      case ',':
        return {
          char: char,
          width: 1
        };
    }

    return null;
  }

  function parseSubpattern(src, pos, onError) {
    var State;

    (function (State) {
      State[State["Prefix"] = 0] = "Prefix";
      State[State["Number"] = 1] = "Number";
      State[State["Suffix"] = 2] = "Suffix";
    })(State || (State = {}));

    var prefix = [];
    var number = [];
    var suffix = [];
    var state = State.Prefix;
    var str = '';

    while (pos < src.length) {
      var char = src[pos];

      if (char === ';') {
        pos += 1;
        break;
      }

      switch (state) {
        case State.Prefix:
          {
            var token = parseAffixToken(src, pos, onError);

            if (token) {
              if (str) {
                prefix.push({
                  char: "'",
                  str: str,
                  width: str.length
                });
                str = '';
              }

              prefix.push(token);
              pos += token.width;
            } else {
              var _token = parseNumberToken(src, pos);

              if (_token) {
                if (str) {
                  prefix.push({
                    char: "'",
                    str: str,
                    width: str.length
                  });
                  str = '';
                }

                state = State.Number;
                number.push(_token);
                pos += _token.width;
              } else {
                str += char;
                pos += 1;
              }
            }

            break;
          }

        case State.Number:
          {
            var _token2 = parseNumberToken(src, pos);

            if (_token2) {
              number.push(_token2);
              pos += _token2.width;
            } else {
              state = State.Suffix;
            }

            break;
          }

        case State.Suffix:
          {
            var _token3 = parseAffixToken(src, pos, onError);

            if (_token3) {
              if (str) {
                suffix.push({
                  char: "'",
                  str: str,
                  width: str.length
                });
                str = '';
              }

              suffix.push(_token3);
              pos += _token3.width;
            } else {
              str += char;
              pos += 1;
            }

            break;
          }
      }
    }

    if (str) suffix.push({
      char: "'",
      str: str,
      width: str.length
    });
    return {
      pattern: {
        prefix: prefix,
        number: number,
        suffix: suffix
      },
      pos: pos
    };
  }

  function parseTokens(src, onError) {
    var _parseSubpattern = parseSubpattern(src, 0, onError),
        pattern = _parseSubpattern.pattern,
        pos = _parseSubpattern.pos;

    if (pos < src.length) {
      var _parseSubpattern2 = parseSubpattern(src, pos, onError),
          negative = _parseSubpattern2.pattern;

      return {
        tokens: pattern,
        negative: negative
      };
    }

    return {
      tokens: pattern
    };
  }

  function parseNumberAsSkeleton(tokens, onError) {
    var res = {};
    var hasGroups = false;
    var hasExponent = false;
    var intOptional = 0;
    var intDigits = '';
    var decimalPos = -1;
    var fracDigits = '';
    var fracOptional = 0;

    for (var pos = 0; pos < tokens.length; ++pos) {
      var token = tokens[pos];

      switch (token.char) {
        case '#':
          {
            if (decimalPos === -1) {
              if (intDigits) {
                var msg = 'Pattern has # after integer digits';
                onError(new PatternError('#', msg));
              }

              intOptional += token.width;
            } else {
              fracOptional += token.width;
            }

            break;
          }

        case '0':
          {
            if (decimalPos === -1) {
              intDigits += token.digits;
            } else {
              if (fracOptional) {
                var _msg = 'Pattern has digits after # in fraction';
                onError(new PatternError('0', _msg));
              }

              fracDigits += token.digits;
            }

            break;
          }

        case '@':
          {
            if (res.precision) onError(new MaskedValueError('precision', res.precision));
            res.precision = {
              style: 'precision-fraction',
              minSignificant: token.min,
              maxSignificant: token.width
            };
            break;
          }

        case ',':
          hasGroups = true;
          break;

        case '.':
          if (decimalPos === 1) {
            var _msg2 = 'Pattern has more than one decimal separator';
            onError(new PatternError('.', _msg2));
          }

          decimalPos = pos;
          break;

        case 'E':
          {
            if (hasExponent) onError(new MaskedValueError('exponent', res.notation));

            if (hasGroups) {
              var _msg3 = 'Exponential patterns may not contain grouping separators';
              onError(new PatternError('E', _msg3));
            }

            res.notation = {
              style: 'scientific'
            };
            if (token.expDigits > 1) res.notation.expDigits = token.expDigits;
            if (token.plus) res.notation.expSign = 'sign-always';
            hasExponent = true;
          }
      }
    } // imprecise mapping due to paradigm differences


    if (hasGroups) res.group = 'group-auto';else if (intOptional + intDigits.length > 3) res.group = 'group-off';
    var increment = Number("".concat(intDigits || '0', ".").concat(fracDigits));
    if (increment) res.precision = {
      style: 'precision-increment',
      increment: increment
    };

    if (!hasExponent) {
      if (intDigits.length > 1) res.integerWidth = {
        min: intDigits.length
      };

      if (!res.precision && (fracDigits.length || fracOptional)) {
        res.precision = {
          style: 'precision-fraction',
          minFraction: fracDigits.length,
          maxFraction: fracDigits.length + fracOptional
        };
      }
    } else {
      if (!res.precision || increment) {
        res.integerWidth = intOptional ? {
          min: 1,
          max: intOptional + intDigits.length
        } : {
          min: Math.max(1, intDigits.length)
        };
      }

      if (res.precision) {
        if (!increment) res.integerWidth = {
          min: 1,
          max: 1
        };
      } else {
        var dc = intDigits.length + fracDigits.length;

        if (decimalPos === -1) {
          if (dc > 0) res.precision = {
            style: 'precision-fraction',
            maxSignificant: dc
          };
        } else {
          res.precision = {
            style: 'precision-fraction',
            maxSignificant: Math.max(1, dc) + fracOptional
          };
          if (dc > 1) res.precision.minSignificant = dc;
        }
      }
    }

    return res;
  }

  function handleAffix(affixTokens, res, currency, onError, isPrefix) {
    var inFmt = false;
    var str = '';

    var _iterator = _createForOfIteratorHelper(affixTokens),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var token = _step.value;

        switch (token.char) {
          case '%':
            res.unit = {
              style: token.style
            };
            if (isPrefix) inFmt = true;else str = '';
            break;

          case '¤':
            if (!currency) {
              var msg = "The \xA4 pattern requires a currency";
              onError(new PatternError('¤', msg));
              break;
            }

            res.unit = {
              style: 'currency',
              currency: currency
            };

            switch (token.currency) {
              case 'iso-code':
                res.unitWidth = 'unit-width-iso-code';
                break;

              case 'full-name':
                res.unitWidth = 'unit-width-full-name';
                break;

              case 'narrow':
                res.unitWidth = 'unit-width-narrow';
                break;
            }

            if (isPrefix) inFmt = true;else str = '';
            break;

          case '*':
            // TODO
            break;

          case '+':
            if (!inFmt) str += '+';
            break;

          case "'":
            if (!inFmt) str += token.str;
            break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return str;
  }

  function getNegativeAffix(affixTokens, isPrefix) {
    var inFmt = false;
    var str = '';

    var _iterator2 = _createForOfIteratorHelper(affixTokens),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var token = _step2.value;

        switch (token.char) {
          case '%':
          case '¤':
            if (isPrefix) inFmt = true;else str = '';
            break;

          case '-':
            if (!inFmt) str += '-';
            break;

          case "'":
            if (!inFmt) str += token.str;
            break;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return str;
  }
  /**
   * Parse an {@link
   * http://unicode.org/reports/tr35/tr35-numbers.html#Number_Format_Patterns |
   * ICU NumberFormatter pattern} string into a {@link Skeleton} structure.
   *
   * @public
   * @param src - The pattern string
   * @param currency - If the pattern includes ¤ tokens, their skeleton
   *   representation requires a three-letter currency code.
   * @param onError - Called when the parser encounters a syntax error. The
   *   function will still return a {@link Skeleton}, but it will be incomplete
   *   and/or inaccurate. If not defined, the error will be thrown instead.
   *
   * @remarks
   * Unlike the skeleton parser, the pattern parser is not able to return partial
   * results on error, and will instead throw. Output padding is not supported.
   *
   * @example
   * ```js
   * import { parseNumberPattern } from 'messageformat-number-skeleton'
   *
   * parseNumberPattern('#,##0.00 ¤', 'EUR', console.error)
   * // {
   * //   group: 'group-auto',
   * //   precision: {
   * //     style: 'precision-fraction',
   * //     minFraction: 2,
   * //     maxFraction: 2
   * //   },
   * //   unit: { style: 'currency', currency: 'EUR' }
   * // }
   * ```
   */


  function parseNumberPattern(src, currency) {
    var onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (error) {
      throw error;
    };

    var _parseTokens = parseTokens(src, onError),
        tokens = _parseTokens.tokens,
        negative = _parseTokens.negative;

    var res = parseNumberAsSkeleton(tokens.number, onError);
    var prefix = handleAffix(tokens.prefix, res, currency, onError, true);
    var suffix = handleAffix(tokens.suffix, res, currency, onError, false);

    if (negative) {
      var negPrefix = getNegativeAffix(negative.prefix, true);
      var negSuffix = getNegativeAffix(negative.suffix, false);
      res.affix = {
        pos: [prefix, suffix],
        neg: [negPrefix, negSuffix]
      };
      res.sign = 'sign-never';
    } else if (prefix || suffix) {
      res.affix = {
        pos: [prefix, suffix]
      };
    }

    return res;
  }

  /** @internal */
  function isNumberingSystem(ns) {
    var systems = ['arab', 'arabext', 'bali', 'beng', 'deva', 'fullwide', 'gujr', 'guru', 'hanidec', 'khmr', 'knda', 'laoo', 'latn', 'limb', 'mlym', 'mong', 'mymr', 'orya', 'tamldec', 'telu', 'thai', 'tibt'];
    return systems.indexOf(ns) !== -1;
  }

  // FIXME: subtype is not checked

  /** @internal */
  function isUnit(unit) {
    var types = ['acceleration', 'angle', 'area', 'concentr', 'consumption', 'digital', 'duration', 'electric', 'energy', 'force', 'frequency', 'graphics', 'length', 'light', 'mass', 'power', 'pressure', 'speed', 'temperature', 'torque', 'volume'];

    var _unit$split = unit.split('-', 1),
        _unit$split2 = _slicedToArray(_unit$split, 1),
        type = _unit$split2[0];

    return types.indexOf(type) !== -1;
  }

  var maxOptions = {
    'compact-short': 0,
    'compact-long': 0,
    'notation-simple': 0,
    scientific: 2,
    engineering: 2,
    percent: 0,
    permille: 0,
    'base-unit': 0,
    currency: 1,
    'measure-unit': 1,
    'per-measure-unit': 1,
    'unit-width-narrow': 0,
    'unit-width-short': 0,
    'unit-width-full-name': 0,
    'unit-width-iso-code': 0,
    'unit-width-hidden': 0,
    'precision-integer': 0,
    'precision-unlimited': 0,
    'precision-currency-standard': 0,
    'precision-currency-cash': 0,
    'precision-increment': 1,
    'rounding-mode-ceiling': 0,
    'rounding-mode-floor': 0,
    'rounding-mode-down': 0,
    'rounding-mode-up': 0,
    'rounding-mode-half-even': 0,
    'rounding-mode-half-down': 0,
    'rounding-mode-half-up': 0,
    'rounding-mode-unnecessary': 0,
    'integer-width': 1,
    scale: 1,
    'group-off': 0,
    'group-min2': 0,
    'group-auto': 0,
    'group-on-aligned': 0,
    'group-thousands': 0,
    latin: 0,
    'numbering-system': 1,
    'sign-auto': 0,
    'sign-always': 0,
    'sign-never': 0,
    'sign-accounting': 0,
    'sign-accounting-always': 0,
    'sign-except-zero': 0,
    'sign-accounting-except-zero': 0,
    'decimal-auto': 0,
    'decimal-always': 0
  };
  var minOptions = {
    currency: 1,
    'integer-width': 1,
    'measure-unit': 1,
    'numbering-system': 1,
    'per-measure-unit': 1,
    'precision-increment': 1,
    scale: 1
  };

  function hasMaxOption(stem) {
    return stem in maxOptions;
  }

  function hasMinOption(stem) {
    return stem in minOptions;
  }
  /** @internal */


  function validOptions(stem, options, onError) {
    if (hasMaxOption(stem)) {
      var maxOpt = maxOptions[stem];

      if (options.length > maxOpt) {
        if (maxOpt === 0) {
          var _iterator = _createForOfIteratorHelper(options),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var opt = _step.value;
              onError(new BadOptionError(stem, opt));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {
          onError(new TooManyOptionsError(stem, options, maxOpt));
        }

        return false;
      } else if (hasMinOption(stem) && options.length < minOptions[stem]) {
        onError(new MissingOptionError(stem));
        return false;
      }
    }

    return true;
  }

  function parseBlueprintDigits(src, style) {
    var re = style === 'fraction' ? /^\.(0*)(\+|#*)$/ : /^(@+)(\+|#*)$/;
    var match = src && src.match(re);

    if (match) {
      var min = match[1].length;

      switch (match[2].charAt(0)) {
        case '':
          return {
            min: min,
            max: min
          };

        case '+':
          return {
            min: min,
            max: null
          };

        case '#':
          {
            return {
              min: min,
              max: min + match[2].length
            };
          }
      }
    }

    return null;
  }

  function parsePrecisionBlueprint(stem, options, onError) {
    var fd = parseBlueprintDigits(stem, 'fraction');

    if (fd) {
      if (options.length > 1) onError(new TooManyOptionsError(stem, options, 1));
      var res = {
        style: 'precision-fraction',
        source: stem,
        minFraction: fd.min
      };
      if (fd.max != null) res.maxFraction = fd.max;
      var option = options[0];

      var _sd = parseBlueprintDigits(option, 'significant');

      if (_sd) {
        res.source = "".concat(stem, "/").concat(option);
        res.minSignificant = _sd.min;
        if (_sd.max != null) res.maxSignificant = _sd.max;
      } else if (option) onError(new BadOptionError(stem, option));

      return res;
    }

    var sd = parseBlueprintDigits(stem, 'significant');

    if (sd) {
      var _iterator = _createForOfIteratorHelper(options),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var opt = _step.value;
          onError(new BadOptionError(stem, opt));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _res = {
        style: 'precision-fraction',
        source: stem,
        minSignificant: sd.min
      };
      if (sd.max != null) _res.maxSignificant = sd.max;
      return _res;
    }

    return null;
  }

  /** @internal */

  var TokenParser = /*#__PURE__*/function () {
    function TokenParser(onError) {
      _classCallCheck(this, TokenParser);

      this.skeleton = {};
      this.onError = onError;
    }

    _createClass(TokenParser, [{
      key: "badOption",
      value: function badOption(stem, opt) {
        this.onError(new BadOptionError(stem, opt));
      }
    }, {
      key: "assertEmpty",
      value: function assertEmpty(key) {
        var prev = this.skeleton[key];
        if (prev) this.onError(new MaskedValueError(key, prev));
      }
    }, {
      key: "parseToken",
      value: function parseToken(stem, options) {
        if (!validOptions(stem, options, this.onError)) return;
        var option = options[0];
        var res = this.skeleton;

        switch (stem) {
          // notation
          case 'compact-short':
          case 'compact-long':
          case 'notation-simple':
            this.assertEmpty('notation');
            res.notation = {
              style: stem
            };
            break;

          case 'scientific':
          case 'engineering':
            {
              var expDigits = null;
              var expSign = undefined;

              var _iterator = _createForOfIteratorHelper(options),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var opt = _step.value;

                  switch (opt) {
                    case 'sign-auto':
                    case 'sign-always':
                    case 'sign-never':
                    case 'sign-accounting':
                    case 'sign-accounting-always':
                    case 'sign-except-zero':
                    case 'sign-accounting-except-zero':
                      expSign = opt;
                      break;

                    default:
                      if (/^\+e+$/.test(opt)) expDigits = opt.length - 1;else {
                        this.badOption(stem, opt);
                      }
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              this.assertEmpty('notation');
              var source = options.join('/');
              res.notation = expDigits && expSign ? {
                style: stem,
                source: source,
                expDigits: expDigits,
                expSign: expSign
              } : expDigits ? {
                style: stem,
                source: source,
                expDigits: expDigits
              } : expSign ? {
                style: stem,
                source: source,
                expSign: expSign
              } : {
                style: stem,
                source: source
              };
              break;
            }
          // unit

          case 'percent':
          case 'permille':
          case 'base-unit':
            this.assertEmpty('unit');
            res.unit = {
              style: stem
            };
            break;

          case 'currency':
            if (/^[A-Z]{3}$/.test(option)) {
              this.assertEmpty('unit');
              res.unit = {
                style: stem,
                currency: option
              };
            } else this.badOption(stem, option);

            break;

          case 'measure-unit':
            {
              if (isUnit(option)) {
                this.assertEmpty('unit');
                res.unit = {
                  style: stem,
                  unit: option
                };
              } else this.badOption(stem, option);

              break;
            }
          // unitPer

          case 'per-measure-unit':
            {
              if (isUnit(option)) {
                this.assertEmpty('unitPer');
                res.unitPer = option;
              } else this.badOption(stem, option);

              break;
            }
          // unitWidth

          case 'unit-width-narrow':
          case 'unit-width-short':
          case 'unit-width-full-name':
          case 'unit-width-iso-code':
          case 'unit-width-hidden':
            this.assertEmpty('unitWidth');
            res.unitWidth = stem;
            break;
          // precision

          case 'precision-integer':
          case 'precision-unlimited':
          case 'precision-currency-standard':
          case 'precision-currency-cash':
            this.assertEmpty('precision');
            res.precision = {
              style: stem
            };
            break;

          case 'precision-increment':
            {
              var increment = Number(option);

              if (increment > 0) {
                this.assertEmpty('precision');
                res.precision = {
                  style: stem,
                  increment: increment
                };
              } else this.badOption(stem, option);

              break;
            }
          // roundingMode

          case 'rounding-mode-ceiling':
          case 'rounding-mode-floor':
          case 'rounding-mode-down':
          case 'rounding-mode-up':
          case 'rounding-mode-half-even':
          case 'rounding-mode-half-down':
          case 'rounding-mode-half-up':
          case 'rounding-mode-unnecessary':
            this.assertEmpty('roundingMode');
            res.roundingMode = stem;
            break;
          // integerWidth

          case 'integer-width':
            {
              if (/^\+0*$/.test(option)) {
                this.assertEmpty('integerWidth');
                res.integerWidth = {
                  source: option,
                  min: option.length - 1
                };
              } else {
                var m = option.match(/^#*(0*)$/);

                if (m) {
                  this.assertEmpty('integerWidth');
                  res.integerWidth = {
                    source: option,
                    min: m[1].length,
                    max: m[0].length
                  };
                } else this.badOption(stem, option);
              }

              break;
            }
          // scale

          case 'scale':
            {
              var scale = Number(option);

              if (scale > 0) {
                this.assertEmpty('scale');
                res.scale = scale;
              } else this.badOption(stem, option);

              break;
            }
          // group

          case 'group-off':
          case 'group-min2':
          case 'group-auto':
          case 'group-on-aligned':
          case 'group-thousands':
            this.assertEmpty('group');
            res.group = stem;
            break;
          // numberingSystem

          case 'latin':
            this.assertEmpty('numberingSystem');
            res.numberingSystem = 'latn';
            break;

          case 'numbering-system':
            {
              if (isNumberingSystem(option)) {
                this.assertEmpty('numberingSystem');
                res.numberingSystem = option;
              } else this.badOption(stem, option);

              break;
            }
          // sign

          case 'sign-auto':
          case 'sign-always':
          case 'sign-never':
          case 'sign-accounting':
          case 'sign-accounting-always':
          case 'sign-except-zero':
          case 'sign-accounting-except-zero':
            this.assertEmpty('sign');
            res.sign = stem;
            break;
          // decimal

          case 'decimal-auto':
          case 'decimal-always':
            this.assertEmpty('decimal');
            res.decimal = stem;
            break;
          // precision blueprint

          default:
            {
              var precision = parsePrecisionBlueprint(stem, options, this.onError);

              if (precision) {
                this.assertEmpty('precision');
                res.precision = precision;
              } else {
                this.onError(new BadStemError(stem));
              }
            }
        }
      }
    }]);

    return TokenParser;
  }();

  /**
   * Parse an {@link
   * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md
   * | ICU NumberFormatter skeleton} string into a {@link Skeleton} structure.
   *
   * @public
   * @param src - The skeleton string
   * @param onError - Called when the parser encounters a syntax error. The
   *   function will still return a {@link Skeleton}, but it may not contain
   *   information for all tokens. If not defined, the error will be thrown
   *   instead.
   *
   * @example
   * ```js
   * import { parseNumberSkeleton } from 'messageformat-number-skeleton'
   *
   * parseNumberSkeleton('compact-short currency/GBP', console.error)
   * // {
   * //   notation: { style: 'compact-short' },
   * //   unit: { style: 'currency', currency: 'GBP' }
   * // }
   * ```
   */

  function parseNumberSkeleton(src) {
    var onError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (error) {
      throw error;
    };
    var tokens = [];

    var _iterator = _createForOfIteratorHelper(src.split(' ')),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var part = _step.value;

        if (part) {
          var _options = part.split('/');

          var _stem = _options.shift() || '';

          tokens.push({
            stem: _stem,
            options: _options
          });
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var parser = new TokenParser(onError);

    for (var _i = 0, _tokens = tokens; _i < _tokens.length; _i++) {
      var _tokens$_i = _tokens[_i],
          stem = _tokens$_i.stem,
          options = _tokens$_i.options;
      parser.parseToken(stem, options);
    }

    return parser.skeleton;
  }

  /**
   * Returns a number formatter function for the given locales and number skeleton
   *
   * @remarks
   * Uses `Intl.NumberFormat` internally, including features provided by the
   * {@link https://github.com/tc39/proposal-unified-intl-numberformat | Unified
   * API Proposal}.
   *
   * @public
   * @param locales - One or more valid BCP 47 language tags, e.g. `fr` or `en-CA`
   * @param skeleton - An ICU NumberFormatter pattern or `::`-prefixed skeleton
   *   string, or a parsed `Skeleton` structure
   * @param currency - If `skeleton` is a pattern string that includes ¤ tokens,
   *   their skeleton representation requires a three-letter currency code.
   * @param onError - If defined, will be called separately for each encountered
   *   parsing error and unsupported feature.
   * @example
   * ```js
   * import { getNumberFormatter } from 'messageformat-number-skeleton'
   *
   * let src = ':: currency/CAD unit-width-narrow'
   * let fmt = getNumberFormatter('en-CA', src, console.error)
   * fmt(42) // '$42.00'
   *
   * src = '::percent scale/100'
   * fmt = getNumberFormatter('en', src, console.error)
   * fmt(0.3) // '30%'
   * ```
   */

  function getNumberFormatter(locales, skeleton, currency, onError) {
    if (typeof skeleton === 'string') {
      skeleton = skeleton.indexOf('::') === 0 ? parseNumberSkeleton(skeleton.slice(2), onError) : parseNumberPattern(skeleton, currency, onError);
    }

    var lc = getNumberFormatLocales(locales, skeleton);
    var opt = getNumberFormatOptions(skeleton, onError);
    var mod = getNumberFormatModifier(skeleton);
    var nf = new Intl.NumberFormat(lc, opt);

    if (skeleton.affix) {
      var _skeleton$affix$pos = _slicedToArray(skeleton.affix.pos, 2),
          p0 = _skeleton$affix$pos[0],
          p1 = _skeleton$affix$pos[1];

      var _ref = skeleton.affix.neg || ['', ''],
          _ref2 = _slicedToArray(_ref, 2),
          n0 = _ref2[0],
          n1 = _ref2[1];

      return function (value) {
        var n = nf.format(mod(value));
        return value < 0 ? "".concat(n0).concat(n).concat(n1) : "".concat(p0).concat(n).concat(p1);
      };
    }

    return function (value) {
      return nf.format(mod(value));
    };
  }
  /**
   * Returns a string of JavaScript source that evaluates to a number formatter
   * function with the same `(value: number) => string` signature as the function
   * returned by {@link getNumberFormatter}.
   *
   * @remarks
   * The returned function will memoize an `Intl.NumberFormat` instance that makes
   * use of features provided by the {@link
   * https://github.com/tc39/proposal-unified-intl-numberformat | Unified API
   * Proposal}.
   *
   * @public
   * @param locales - One or more valid BCP 47 language tags, e.g. `fr` or `en-CA`
   * @param skeleton - An ICU NumberFormatter pattern or `::`-prefixed skeleton
   *   string, or a parsed `Skeleton` structure
   * @param currency - If `skeleton` is a pattern string that includes ¤ tokens,
   *   their skeleton representation requires a three-letter currency code.
   * @param onError - If defined, will be called separately for each encountered
   *   parsing error and unsupported feature.
   * @example
   * ```js
   * import { getNumberFormatterSource } from 'messageformat-number-skeleton'
   *
   * getNumberFormatterSource('en', '::percent', console.error)
   * // '(function() {\n' +
   * // '  var opt = {"style":"percent"};\n' +
   * // '  var nf = new Intl.NumberFormat(["en"], opt);\n' +
   * // '  var mod = function(n) { return n * 0.01; };\n' +
   * // '  return function(value) { return nf.format(mod(value)); }\n' +
   * // '})()'
   *
   * const src = getNumberFormatterSource('en-CA', ':: currency/CAD unit-width-narrow', console.error)
   * // '(function() {\n' +
   * // '  var opt = {"style":"currency","currency":"CAD","currencyDisplay":"narrowSymbol","unitDisplay":"narrow"};\n' +
   * // '  var nf = new Intl.NumberFormat(["en-CA"], opt);\n'
   * // '  return function(value) { return nf.format(value); }\n' +
   * // '})()'
   * const fmt = new Function(`return ${src}`)()
   * fmt(42) // '$42.00'
   * ```
   */

  function getNumberFormatterSource(locales, skeleton, currency, onError) {
    if (typeof skeleton === 'string') {
      skeleton = skeleton.indexOf('::') === 0 ? parseNumberSkeleton(skeleton.slice(2), onError) : parseNumberPattern(skeleton, currency, onError);
    }

    var lc = getNumberFormatLocales(locales, skeleton);
    var opt = getNumberFormatOptions(skeleton, onError);
    var modSrc = getNumberFormatModifierSource(skeleton);
    var lines = ["(function() {", "var opt = ".concat(JSON.stringify(opt), ";"), "var nf = new Intl.NumberFormat(".concat(JSON.stringify(lc), ", opt);")];
    var res = 'nf.format(value)';

    if (modSrc) {
      lines.push("var mod = ".concat(modSrc, ";"));
      res = 'nf.format(mod(value))';
    }

    if (skeleton.affix) {
      var _skeleton$affix$pos$m = skeleton.affix.pos.map(function (s) {
        return JSON.stringify(s);
      }),
          _skeleton$affix$pos$m2 = _slicedToArray(_skeleton$affix$pos$m, 2),
          p0 = _skeleton$affix$pos$m2[0],
          p1 = _skeleton$affix$pos$m2[1];

      if (skeleton.affix.neg) {
        var _skeleton$affix$neg$m = skeleton.affix.neg.map(function (s) {
          return JSON.stringify(s);
        }),
            _skeleton$affix$neg$m2 = _slicedToArray(_skeleton$affix$neg$m, 2),
            n0 = _skeleton$affix$neg$m2[0],
            n1 = _skeleton$affix$neg$m2[1];

        res = "value < 0 ? ".concat(n0, " + ").concat(res, " + ").concat(n1, " : ").concat(p0, " + ").concat(res, " + ").concat(p1);
      } else {
        res = "".concat(p0, " + ").concat(res, " + ").concat(p1);
      }
    }

    lines.push("return function(value) { return ".concat(res, "; }"));
    return lines.join('\n  ') + '\n})()';
  }

  /*
   * Generated by PEG.js 0.10.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() {
      this.constructor = child;
    }

    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message = message;
    this.expected = expected;
    this.found = found;
    this.location = location;
    this.name = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  peg$SyntaxError.buildMessage = function (expected, found) {
    var DESCRIBE_EXPECTATION_FNS = {
      literal: function literal(expectation) {
        return "\"" + literalEscape(expectation.text) + "\"";
      },
      "class": function _class(expectation) {
        var escapedParts = "",
            i;

        for (i = 0; i < expectation.parts.length; i++) {
          escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
        }

        return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
      },
      any: function any(expectation) {
        return "any character";
      },
      end: function end(expectation) {
        return "end of input";
      },
      other: function other(expectation) {
        return expectation.description;
      }
    };

    function hex(ch) {
      return ch.charCodeAt(0).toString(16).toUpperCase();
    }

    function literalEscape(s) {
      return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
        return '\\x0' + hex(ch);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return '\\x' + hex(ch);
      });
    }

    function classEscape(s) {
      return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function (ch) {
        return '\\x0' + hex(ch);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
        return '\\x' + hex(ch);
      });
    }

    function describeExpectation(expectation) {
      return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }

    function describeExpected(expected) {
      var descriptions = new Array(expected.length),
          i,
          j;

      for (i = 0; i < expected.length; i++) {
        descriptions[i] = describeExpectation(expected[i]);
      }

      descriptions.sort();

      if (descriptions.length > 0) {
        for (i = 1, j = 1; i < descriptions.length; i++) {
          if (descriptions[i - 1] !== descriptions[i]) {
            descriptions[j] = descriptions[i];
            j++;
          }
        }

        descriptions.length = j;
      }

      switch (descriptions.length) {
        case 1:
          return descriptions[0];

        case 2:
          return descriptions[0] + " or " + descriptions[1];

        default:
          return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
      }
    }

    function describeFound(found) {
      return found ? "\"" + literalEscape(found) + "\"" : "end of input";
    }

    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
  };

  function peg$parse(input, options) {
    options = options !== void 0 ? options : {};

    var peg$FAILED = {},
        peg$startRuleFunctions = {
      start: peg$parsestart
    },
        peg$startRuleFunction = peg$parsestart,
        peg$c0 = "#",
        peg$c1 = peg$literalExpectation("#", false),
        peg$c2 = function peg$c2() {
      return inPlural[0];
    },
        peg$c3 = function peg$c3() {
      return {
        type: 'octothorpe'
      };
    },
        peg$c4 = function peg$c4(str) {
      return str.join('');
    },
        peg$c5 = "{",
        peg$c6 = peg$literalExpectation("{", false),
        peg$c7 = "}",
        peg$c8 = peg$literalExpectation("}", false),
        peg$c9 = function peg$c9(arg) {
      return {
        type: 'argument',
        arg: arg
      };
    },
        peg$c10 = ",",
        peg$c11 = peg$literalExpectation(",", false),
        peg$c12 = "select",
        peg$c13 = peg$literalExpectation("select", false),
        peg$c14 = function peg$c14(arg, m) {
      if (options.strict) {
        inPlural.unshift(false);
      }

      return m;
    },
        peg$c15 = function peg$c15(arg, cases) {
      if (options.strict) inPlural.shift();
      return {
        type: 'select',
        arg: arg,
        cases: cases
      };
    },
        peg$c16 = "plural",
        peg$c17 = peg$literalExpectation("plural", false),
        peg$c18 = "selectordinal",
        peg$c19 = peg$literalExpectation("selectordinal", false),
        peg$c20 = function peg$c20(arg, m) {
      inPlural.unshift(true);
      return m;
    },
        peg$c21 = function peg$c21(arg, type, offset, cases) {
      var ls = (type === 'selectordinal' ? options.ordinal : options.cardinal) || ['zero', 'one', 'two', 'few', 'many', 'other'];
      if (ls && ls.length) cases.forEach(function (c) {
        if (isNaN(c.key) && ls.indexOf(c.key) < 0) throw new Error('Invalid key `' + c.key + '` for argument `' + arg + '`.' + ' Valid ' + type + ' keys for this locale are `' + ls.join('`, `') + '`, and explicit keys like `=0`.');
      });
      inPlural.shift();
      return {
        type: type,
        arg: arg,
        offset: offset || 0,
        cases: cases
      };
    },
        peg$c22 = function peg$c22(arg, key, param) {
      return {
        type: 'function',
        arg: arg,
        key: key,
        param: param
      };
    },
        peg$c23 = peg$otherExpectation("identifier"),
        peg$c24 = /^[^\t-\r \x85\u200E\u200F\u2028\u2029!-\/:-@[-\^`{-~\xA1-\xA7\xA9\xAB\xAC\xAE\xB0\xB1\xB6\xBB\xBF\xD7\xF7\u2010-\u2027\u2030-\u203E\u2041-\u2053\u2055-\u205E\u2190-\u245F\u2500-\u2775\u2794-\u2BFF\u2E00-\u2E7F\u3001-\u3003\u3008-\u3020\u3030\uFD3E\uFD3F\uFE45\uFE46]/,
        peg$c25 = peg$classExpectation([["\t", "\r"], " ", "\x85", "\u200E", "\u200F", "\u2028", "\u2029", ["!", "/"], [":", "@"], ["[", "^"], "`", ["{", "~"], ["\xA1", "\xA7"], "\xA9", "\xAB", "\xAC", "\xAE", "\xB0", "\xB1", "\xB6", "\xBB", "\xBF", "\xD7", "\xF7", ["\u2010", "\u2027"], ["\u2030", "\u203E"], ["\u2041", "\u2053"], ["\u2055", "\u205E"], ["\u2190", "\u245F"], ["\u2500", "\u2775"], ["\u2794", "\u2BFF"], ["\u2E00", "\u2E7F"], ["\u3001", "\u3003"], ["\u3008", "\u3020"], "\u3030", "\uFD3E", "\uFD3F", "\uFE45", "\uFE46"], true, false),
        peg$c26 = function peg$c26(key, tokens) {
      return {
        key: key,
        tokens: tokens
      };
    },
        peg$c27 = function peg$c27(tokens) {
      return tokens;
    },
        peg$c28 = peg$otherExpectation("plural offset"),
        peg$c29 = "offset",
        peg$c30 = peg$literalExpectation("offset", false),
        peg$c31 = ":",
        peg$c32 = peg$literalExpectation(":", false),
        peg$c33 = function peg$c33(d) {
      return d;
    },
        peg$c34 = "=",
        peg$c35 = peg$literalExpectation("=", false),
        peg$c36 = "number",
        peg$c37 = peg$literalExpectation("number", false),
        peg$c38 = "date",
        peg$c39 = peg$literalExpectation("date", false),
        peg$c40 = "time",
        peg$c41 = peg$literalExpectation("time", false),
        peg$c42 = "spellout",
        peg$c43 = peg$literalExpectation("spellout", false),
        peg$c44 = "ordinal",
        peg$c45 = peg$literalExpectation("ordinal", false),
        peg$c46 = "duration",
        peg$c47 = peg$literalExpectation("duration", false),
        peg$c48 = function peg$c48(key) {
      if (options.strict || /^\d/.test(key)) return false;

      switch (key.toLowerCase()) {
        case 'select':
        case 'plural':
        case 'selectordinal':
          return false;

        default:
          return true;
      }
    },
        peg$c49 = function peg$c49(key) {
      return key;
    },
        peg$c50 = function peg$c50(tokens) {
      return !options.strict;
    },
        peg$c51 = function peg$c51(tokens) {
      return {
        tokens: tokens
      };
    },
        peg$c52 = function peg$c52(parts) {
      return {
        tokens: [parts.join('')]
      };
    },
        peg$c53 = peg$otherExpectation("a valid (strict) function parameter"),
        peg$c54 = /^[^'{}]/,
        peg$c55 = peg$classExpectation(["'", "{", "}"], true, false),
        peg$c56 = function peg$c56(p) {
      return p.join('');
    },
        peg$c57 = "'",
        peg$c58 = peg$literalExpectation("'", false),
        peg$c59 = function peg$c59(quoted) {
      return quoted;
    },
        peg$c60 = function peg$c60(p) {
      return '{' + p.join('') + '}';
    },
        peg$c61 = peg$otherExpectation("doubled apostrophe"),
        peg$c62 = "''",
        peg$c63 = peg$literalExpectation("''", false),
        peg$c64 = function peg$c64() {
      return "'";
    },
        peg$c65 = /^[^']/,
        peg$c66 = peg$classExpectation(["'"], true, false),
        peg$c67 = "'{",
        peg$c68 = peg$literalExpectation("'{", false),
        peg$c69 = function peg$c69(str) {
      return "{" + str.join('');
    },
        peg$c70 = "'}",
        peg$c71 = peg$literalExpectation("'}", false),
        peg$c72 = function peg$c72(str) {
      return "}" + str.join('');
    },
        peg$c73 = peg$otherExpectation("escaped string"),
        peg$c74 = "'#",
        peg$c75 = peg$literalExpectation("'#", false),
        peg$c76 = function peg$c76(str) {
      return "#" + str.join('');
    },
        peg$c77 = function peg$c77(quotedOcto) {
      return quotedOcto[0];
    },
        peg$c78 = peg$otherExpectation("plain char"),
        peg$c79 = /^[^{}#\0-\x08\x0E-\x1F\x7F]/,
        peg$c80 = peg$classExpectation(["{", "}", "#", ["\0", "\b"], ["\x0E", "\x1F"], "\x7F"], true, false),
        peg$c81 = function peg$c81(octo) {
      return !inPlural[0];
    },
        peg$c82 = function peg$c82(octo) {
      return octo;
    },
        peg$c83 = peg$otherExpectation("integer"),
        peg$c84 = /^[0-9]/,
        peg$c85 = peg$classExpectation([["0", "9"]], false, false),
        peg$c86 = peg$otherExpectation("white space"),
        peg$c87 = /^[\t-\r \x85\u200E\u200F\u2028\u2029]/,
        peg$c88 = peg$classExpectation([["\t", "\r"], " ", "\x85", "\u200E", "\u200F", "\u2028", "\u2029"], false, false),
        peg$currPos = 0,
        peg$posDetailsCache = [{
      line: 1,
      column: 1
    }],
        peg$maxFailPos = 0,
        peg$maxFailExpected = [],
        peg$silentFails = 0,
        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function peg$literalExpectation(text, ignoreCase) {
      return {
        type: "literal",
        text: text,
        ignoreCase: ignoreCase
      };
    }

    function peg$classExpectation(parts, inverted, ignoreCase) {
      return {
        type: "class",
        parts: parts,
        inverted: inverted,
        ignoreCase: ignoreCase
      };
    }

    function peg$endExpectation() {
      return {
        type: "end"
      };
    }

    function peg$otherExpectation(description) {
      return {
        type: "other",
        description: description
      };
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p;

      if (details) {
        return details;
      } else {
        p = pos - 1;

        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line: details.line,
          column: details.column
        };

        while (p < pos) {
          if (input.charCodeAt(p) === 10) {
            details.line++;
            details.column = 1;
          } else {
            details.column++;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails = peg$computePosDetails(endPos);
      return {
        start: {
          offset: startPos,
          line: startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line: endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) {
        return;
      }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildStructuredError(expected, found, location) {
      return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
    }

    function peg$parsestart() {
      var s0, s1;
      s0 = [];
      s1 = peg$parsetoken();

      while (s1 !== peg$FAILED) {
        s0.push(s1);
        s1 = peg$parsetoken();
      }

      return s0;
    }

    function peg$parsetoken() {
      var s0, s1, s2;
      s0 = peg$parseargument();

      if (s0 === peg$FAILED) {
        s0 = peg$parseselect();

        if (s0 === peg$FAILED) {
          s0 = peg$parseplural();

          if (s0 === peg$FAILED) {
            s0 = peg$parsefunction();

            if (s0 === peg$FAILED) {
              s0 = peg$currPos;

              if (input.charCodeAt(peg$currPos) === 35) {
                s1 = peg$c0;
                peg$currPos++;
              } else {
                s1 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c1);
                }
              }

              if (s1 !== peg$FAILED) {
                s2 = peg$c2();

                if (s2) {
                  s2 = void 0;
                } else {
                  s2 = peg$FAILED;
                }

                if (s2 !== peg$FAILED) {
                  s1 = peg$c3();
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }

              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                s2 = peg$parsechar();

                if (s2 !== peg$FAILED) {
                  while (s2 !== peg$FAILED) {
                    s1.push(s2);
                    s2 = peg$parsechar();
                  }
                } else {
                  s1 = peg$FAILED;
                }

                if (s1 !== peg$FAILED) {
                  s1 = peg$c4(s1);
                }

                s0 = s1;
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2, s3, s4, s5;
      s0 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c6);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseid();

          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();

            if (s4 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 125) {
                s5 = peg$c7;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c8);
                }
              }

              if (s5 !== peg$FAILED) {
                s1 = peg$c9(s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselect() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;
      s0 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c6);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseid();

          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();

            if (s4 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 44) {
                s5 = peg$c10;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c11);
                }
              }

              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();

                if (s6 !== peg$FAILED) {
                  s7 = peg$currPos;

                  if (input.substr(peg$currPos, 6) === peg$c12) {
                    s8 = peg$c12;
                    peg$currPos += 6;
                  } else {
                    s8 = peg$FAILED;

                    if (peg$silentFails === 0) {
                      peg$fail(peg$c13);
                    }
                  }

                  if (s8 !== peg$FAILED) {
                    s8 = peg$c14(s3, s8);
                  }

                  s7 = s8;

                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();

                    if (s8 !== peg$FAILED) {
                      if (input.charCodeAt(peg$currPos) === 44) {
                        s9 = peg$c10;
                        peg$currPos++;
                      } else {
                        s9 = peg$FAILED;

                        if (peg$silentFails === 0) {
                          peg$fail(peg$c11);
                        }
                      }

                      if (s9 !== peg$FAILED) {
                        s10 = peg$parse_();

                        if (s10 !== peg$FAILED) {
                          s11 = [];
                          s12 = peg$parseselectCase();

                          if (s12 !== peg$FAILED) {
                            while (s12 !== peg$FAILED) {
                              s11.push(s12);
                              s12 = peg$parseselectCase();
                            }
                          } else {
                            s11 = peg$FAILED;
                          }

                          if (s11 !== peg$FAILED) {
                            s12 = peg$parse_();

                            if (s12 !== peg$FAILED) {
                              if (input.charCodeAt(peg$currPos) === 125) {
                                s13 = peg$c7;
                                peg$currPos++;
                              } else {
                                s13 = peg$FAILED;

                                if (peg$silentFails === 0) {
                                  peg$fail(peg$c8);
                                }
                              }

                              if (s13 !== peg$FAILED) {
                                s1 = peg$c15(s3, s11);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseplural() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14;
      s0 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c6);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseid();

          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();

            if (s4 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 44) {
                s5 = peg$c10;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c11);
                }
              }

              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();

                if (s6 !== peg$FAILED) {
                  s7 = peg$currPos;

                  if (input.substr(peg$currPos, 6) === peg$c16) {
                    s8 = peg$c16;
                    peg$currPos += 6;
                  } else {
                    s8 = peg$FAILED;

                    if (peg$silentFails === 0) {
                      peg$fail(peg$c17);
                    }
                  }

                  if (s8 === peg$FAILED) {
                    if (input.substr(peg$currPos, 13) === peg$c18) {
                      s8 = peg$c18;
                      peg$currPos += 13;
                    } else {
                      s8 = peg$FAILED;

                      if (peg$silentFails === 0) {
                        peg$fail(peg$c19);
                      }
                    }
                  }

                  if (s8 !== peg$FAILED) {
                    s8 = peg$c20(s3, s8);
                  }

                  s7 = s8;

                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();

                    if (s8 !== peg$FAILED) {
                      if (input.charCodeAt(peg$currPos) === 44) {
                        s9 = peg$c10;
                        peg$currPos++;
                      } else {
                        s9 = peg$FAILED;

                        if (peg$silentFails === 0) {
                          peg$fail(peg$c11);
                        }
                      }

                      if (s9 !== peg$FAILED) {
                        s10 = peg$parse_();

                        if (s10 !== peg$FAILED) {
                          s11 = peg$parseoffset();

                          if (s11 === peg$FAILED) {
                            s11 = null;
                          }

                          if (s11 !== peg$FAILED) {
                            s12 = [];
                            s13 = peg$parsepluralCase();

                            if (s13 !== peg$FAILED) {
                              while (s13 !== peg$FAILED) {
                                s12.push(s13);
                                s13 = peg$parsepluralCase();
                              }
                            } else {
                              s12 = peg$FAILED;
                            }

                            if (s12 !== peg$FAILED) {
                              s13 = peg$parse_();

                              if (s13 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 125) {
                                  s14 = peg$c7;
                                  peg$currPos++;
                                } else {
                                  s14 = peg$FAILED;

                                  if (peg$silentFails === 0) {
                                    peg$fail(peg$c8);
                                  }
                                }

                                if (s14 !== peg$FAILED) {
                                  s1 = peg$c21(s3, s7, s11, s12);
                                  s0 = s1;
                                } else {
                                  peg$currPos = s0;
                                  s0 = peg$FAILED;
                                }
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsefunction() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;
      s0 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c6);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();

        if (s2 !== peg$FAILED) {
          s3 = peg$parseid();

          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();

            if (s4 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 44) {
                s5 = peg$c10;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c11);
                }
              }

              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();

                if (s6 !== peg$FAILED) {
                  s7 = peg$parsefunctionKey();

                  if (s7 !== peg$FAILED) {
                    s8 = peg$parse_();

                    if (s8 !== peg$FAILED) {
                      s9 = peg$parsefunctionParam();

                      if (s9 === peg$FAILED) {
                        s9 = null;
                      }

                      if (s9 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 125) {
                          s10 = peg$c7;
                          peg$currPos++;
                        } else {
                          s10 = peg$FAILED;

                          if (peg$silentFails === 0) {
                            peg$fail(peg$c8);
                          }
                        }

                        if (s10 !== peg$FAILED) {
                          s1 = peg$c22(s3, s7, s9);
                          s0 = s1;
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseid() {
      var s0, s1, s2;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];

      if (peg$c24.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c25);
        }
      }

      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);

          if (peg$c24.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c25);
            }
          }
        }
      } else {
        s1 = peg$FAILED;
      }

      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c23);
        }
      }

      return s0;
    }

    function peg$parseselectCase() {
      var s0, s1, s2, s3, s4;
      s0 = peg$currPos;
      s1 = peg$parse_();

      if (s1 !== peg$FAILED) {
        s2 = peg$parseid();

        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();

          if (s3 !== peg$FAILED) {
            s4 = peg$parsecaseTokens();

            if (s4 !== peg$FAILED) {
              s1 = peg$c26(s2, s4);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralCase() {
      var s0, s1, s2, s3, s4;
      s0 = peg$currPos;
      s1 = peg$parse_();

      if (s1 !== peg$FAILED) {
        s2 = peg$parsepluralKey();

        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();

          if (s3 !== peg$FAILED) {
            s4 = peg$parsecaseTokens();

            if (s4 !== peg$FAILED) {
              s1 = peg$c26(s2, s4);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsecaseTokens() {
      var s0, s1, s2, s3, s4, s5;
      s0 = peg$currPos;

      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c6);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = peg$currPos;
        s3 = peg$parse_();

        if (s3 !== peg$FAILED) {
          s4 = peg$currPos;
          peg$silentFails++;

          if (input.charCodeAt(peg$currPos) === 123) {
            s5 = peg$c5;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c6);
            }
          }

          peg$silentFails--;

          if (s5 !== peg$FAILED) {
            peg$currPos = s4;
            s4 = void 0;
          } else {
            s4 = peg$FAILED;
          }

          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }

        if (s2 === peg$FAILED) {
          s2 = null;
        }

        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parsetoken();

          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = peg$parsetoken();
          }

          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();

            if (s4 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 125) {
                s5 = peg$c7;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c8);
                }
              }

              if (s5 !== peg$FAILED) {
                s1 = peg$c27(s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3, s4, s5, s6, s7;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = peg$parse_();

      if (s1 !== peg$FAILED) {
        if (input.substr(peg$currPos, 6) === peg$c29) {
          s2 = peg$c29;
          peg$currPos += 6;
        } else {
          s2 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c30);
          }
        }

        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();

          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 58) {
              s4 = peg$c31;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c32);
              }
            }

            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();

              if (s5 !== peg$FAILED) {
                s6 = peg$parsedigits();

                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();

                  if (s7 !== peg$FAILED) {
                    s1 = peg$c33(s6);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c28);
        }
      }

      return s0;
    }

    function peg$parsepluralKey() {
      var s0, s1, s2;
      s0 = peg$parseid();

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;

        if (input.charCodeAt(peg$currPos) === 61) {
          s1 = peg$c34;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c35);
          }
        }

        if (s1 !== peg$FAILED) {
          s2 = peg$parsedigits();

          if (s2 !== peg$FAILED) {
            s1 = peg$c33(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }

      return s0;
    }

    function peg$parsefunctionKey() {
      var s0, s1, s2, s3, s4, s5;

      if (input.substr(peg$currPos, 6) === peg$c36) {
        s0 = peg$c36;
        peg$currPos += 6;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c37);
        }
      }

      if (s0 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c38) {
          s0 = peg$c38;
          peg$currPos += 4;
        } else {
          s0 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c39);
          }
        }

        if (s0 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c40) {
            s0 = peg$c40;
            peg$currPos += 4;
          } else {
            s0 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c41);
            }
          }

          if (s0 === peg$FAILED) {
            if (input.substr(peg$currPos, 8) === peg$c42) {
              s0 = peg$c42;
              peg$currPos += 8;
            } else {
              s0 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c43);
              }
            }

            if (s0 === peg$FAILED) {
              if (input.substr(peg$currPos, 7) === peg$c44) {
                s0 = peg$c44;
                peg$currPos += 7;
              } else {
                s0 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c45);
                }
              }

              if (s0 === peg$FAILED) {
                if (input.substr(peg$currPos, 8) === peg$c46) {
                  s0 = peg$c46;
                  peg$currPos += 8;
                } else {
                  s0 = peg$FAILED;

                  if (peg$silentFails === 0) {
                    peg$fail(peg$c47);
                  }
                }

                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;
                  s1 = peg$currPos;
                  peg$silentFails++;

                  if (input.substr(peg$currPos, 6) === peg$c12) {
                    s2 = peg$c12;
                    peg$currPos += 6;
                  } else {
                    s2 = peg$FAILED;

                    if (peg$silentFails === 0) {
                      peg$fail(peg$c13);
                    }
                  }

                  peg$silentFails--;

                  if (s2 === peg$FAILED) {
                    s1 = void 0;
                  } else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                  }

                  if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    peg$silentFails++;

                    if (input.substr(peg$currPos, 6) === peg$c16) {
                      s3 = peg$c16;
                      peg$currPos += 6;
                    } else {
                      s3 = peg$FAILED;

                      if (peg$silentFails === 0) {
                        peg$fail(peg$c17);
                      }
                    }

                    peg$silentFails--;

                    if (s3 === peg$FAILED) {
                      s2 = void 0;
                    } else {
                      peg$currPos = s2;
                      s2 = peg$FAILED;
                    }

                    if (s2 !== peg$FAILED) {
                      s3 = peg$currPos;
                      peg$silentFails++;

                      if (input.substr(peg$currPos, 13) === peg$c18) {
                        s4 = peg$c18;
                        peg$currPos += 13;
                      } else {
                        s4 = peg$FAILED;

                        if (peg$silentFails === 0) {
                          peg$fail(peg$c19);
                        }
                      }

                      peg$silentFails--;

                      if (s4 === peg$FAILED) {
                        s3 = void 0;
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }

                      if (s3 !== peg$FAILED) {
                        s4 = peg$parseid();

                        if (s4 !== peg$FAILED) {
                          s5 = peg$c48(s4);

                          if (s5) {
                            s5 = void 0;
                          } else {
                            s5 = peg$FAILED;
                          }

                          if (s5 !== peg$FAILED) {
                            s1 = peg$c49(s4);
                            s0 = s1;
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsefunctionParam() {
      var s0, s1, s2, s3, s4;
      s0 = peg$currPos;
      s1 = peg$parse_();

      if (s1 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 44) {
          s2 = peg$c10;
          peg$currPos++;
        } else {
          s2 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c11);
          }
        }

        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parsetoken();

          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = peg$parsetoken();
          }

          if (s3 !== peg$FAILED) {
            s4 = peg$c50();

            if (s4) {
              s4 = void 0;
            } else {
              s4 = peg$FAILED;
            }

            if (s4 !== peg$FAILED) {
              s1 = peg$c51(s3);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parse_();

        if (s1 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s2 = peg$c10;
            peg$currPos++;
          } else {
            s2 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c11);
            }
          }

          if (s2 !== peg$FAILED) {
            s3 = [];
            s4 = peg$parsestrictFunctionParamPart();

            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parsestrictFunctionParamPart();
            }

            if (s3 !== peg$FAILED) {
              s1 = peg$c52(s3);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }

      return s0;
    }

    function peg$parsestrictFunctionParamPart() {
      var s0, s1, s2, s3;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];

      if (peg$c54.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c55);
        }
      }

      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);

          if (peg$c54.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c55);
            }
          }
        }
      } else {
        s1 = peg$FAILED;
      }

      if (s1 !== peg$FAILED) {
        s1 = peg$c56(s1);
      }

      s0 = s1;

      if (s0 === peg$FAILED) {
        s0 = peg$parsedoubleapos();

        if (s0 === peg$FAILED) {
          s0 = peg$currPos;

          if (input.charCodeAt(peg$currPos) === 39) {
            s1 = peg$c57;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c58);
            }
          }

          if (s1 !== peg$FAILED) {
            s2 = peg$parseinapos();

            if (s2 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 39) {
                s3 = peg$c57;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;

                if (peg$silentFails === 0) {
                  peg$fail(peg$c58);
                }
              }

              if (s3 !== peg$FAILED) {
                s1 = peg$c59(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }

          if (s0 === peg$FAILED) {
            s0 = peg$currPos;

            if (input.charCodeAt(peg$currPos) === 123) {
              s1 = peg$c5;
              peg$currPos++;
            } else {
              s1 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c6);
              }
            }

            if (s1 !== peg$FAILED) {
              s2 = [];
              s3 = peg$parsestrictFunctionParamPart();

              while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$parsestrictFunctionParamPart();
              }

              if (s2 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 125) {
                  s3 = peg$c7;
                  peg$currPos++;
                } else {
                  s3 = peg$FAILED;

                  if (peg$silentFails === 0) {
                    peg$fail(peg$c8);
                  }
                }

                if (s3 !== peg$FAILED) {
                  s1 = peg$c60(s2);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
        }
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c53);
        }
      }

      return s0;
    }

    function peg$parsedoubleapos() {
      var s0, s1;
      peg$silentFails++;
      s0 = peg$currPos;

      if (input.substr(peg$currPos, 2) === peg$c62) {
        s1 = peg$c62;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c63);
        }
      }

      if (s1 !== peg$FAILED) {
        s1 = peg$c64();
      }

      s0 = s1;
      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c61);
        }
      }

      return s0;
    }

    function peg$parseinapos() {
      var s0, s1, s2;
      s0 = peg$parsedoubleapos();

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];

        if (peg$c65.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c66);
          }
        }

        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);

            if (peg$c65.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c66);
              }
            }
          }
        } else {
          s1 = peg$FAILED;
        }

        if (s1 !== peg$FAILED) {
          s1 = peg$c4(s1);
        }

        s0 = s1;
      }

      return s0;
    }

    function peg$parsequotedCurly() {
      var s0, s1, s2, s3;
      s0 = peg$currPos;

      if (input.substr(peg$currPos, 2) === peg$c67) {
        s1 = peg$c67;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c68);
        }
      }

      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$parseinapos();

        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseinapos();
        }

        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 39) {
            s3 = peg$c57;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c58);
            }
          }

          if (s3 !== peg$FAILED) {
            s1 = peg$c69(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;

        if (input.substr(peg$currPos, 2) === peg$c70) {
          s1 = peg$c70;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c71);
          }
        }

        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$parseinapos();

          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$parseinapos();
          }

          if (s2 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 39) {
              s3 = peg$c57;
              peg$currPos++;
            } else {
              s3 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c58);
              }
            }

            if (s3 !== peg$FAILED) {
              s1 = peg$c72(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }

      return s0;
    }

    function peg$parsequoted() {
      var s0, s1, s2, s3, s4, s5;
      peg$silentFails++;
      s0 = peg$parsequotedCurly();

      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = peg$currPos;

        if (input.substr(peg$currPos, 2) === peg$c74) {
          s3 = peg$c74;
          peg$currPos += 2;
        } else {
          s3 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c75);
          }
        }

        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parseinapos();

          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parseinapos();
          }

          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 39) {
              s5 = peg$c57;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;

              if (peg$silentFails === 0) {
                peg$fail(peg$c58);
              }
            }

            if (s5 !== peg$FAILED) {
              s3 = peg$c76(s4);
              s2 = s3;
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }

        if (s2 !== peg$FAILED) {
          s3 = peg$c2();

          if (s3) {
            s3 = void 0;
          } else {
            s3 = peg$FAILED;
          }

          if (s3 !== peg$FAILED) {
            s2 = [s2, s3];
            s1 = s2;
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }

        if (s1 !== peg$FAILED) {
          s1 = peg$c77(s1);
        }

        s0 = s1;

        if (s0 === peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 39) {
            s0 = peg$c57;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c58);
            }
          }
        }
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c73);
        }
      }

      return s0;
    }

    function peg$parseplainChar() {
      var s0;
      peg$silentFails++;

      if (peg$c79.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c80);
        }
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {

        if (peg$silentFails === 0) {
          peg$fail(peg$c78);
        }
      }

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2;
      s0 = peg$parsedoubleapos();

      if (s0 === peg$FAILED) {
        s0 = peg$parsequoted();

        if (s0 === peg$FAILED) {
          s0 = peg$currPos;

          if (input.charCodeAt(peg$currPos) === 35) {
            s1 = peg$c0;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c1);
            }
          }

          if (s1 !== peg$FAILED) {
            s2 = peg$c81();

            if (s2) {
              s2 = void 0;
            } else {
              s2 = peg$FAILED;
            }

            if (s2 !== peg$FAILED) {
              s1 = peg$c82(s1);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }

          if (s0 === peg$FAILED) {
            s0 = peg$parseplainChar();
          }
        }
      }

      return s0;
    }

    function peg$parsedigits() {
      var s0, s1, s2;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];

      if (peg$c84.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c85);
        }
      }

      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);

          if (peg$c84.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;

            if (peg$silentFails === 0) {
              peg$fail(peg$c85);
            }
          }
        }
      } else {
        s1 = peg$FAILED;
      }

      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c83);
        }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;
      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];

      if (peg$c87.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c88);
        }
      }

      while (s2 !== peg$FAILED) {
        s1.push(s2);

        if (peg$c87.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;

          if (peg$silentFails === 0) {
            peg$fail(peg$c88);
          }
        }
      }

      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }

      peg$silentFails--;

      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;

        if (peg$silentFails === 0) {
          peg$fail(peg$c86);
        }
      }

      return s0;
    }

    var inPlural = [false];
    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail(peg$endExpectation());
      }

      throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
  }

  var parser = {
    SyntaxError: peg$SyntaxError,
    parse: peg$parse
  };
  var parser_1 = parser.parse;

  function _nf(lc) {
    return _nf[lc] || (_nf[lc] = new Intl.NumberFormat(lc));
  }
  function number(lc, value, offset) {
    return _nf(lc).format(value - offset);
  }
  function strictNumber(lc, value, offset, name) {
    var n = value - offset;
    if (isNaN(n)) throw new Error('`' + name + '` or its offset is not a number');
    return _nf(lc).format(n);
  }
  function plural(value, offset, lcfunc, data, isOrdinal) {
    if ({}.hasOwnProperty.call(data, value)) return data[value];
    if (offset) value -= offset;
    var key = lcfunc(value, isOrdinal);
    return key in data ? data[key] : data.other;
  }
  function select(value, data) {
    return {}.hasOwnProperty.call(data, value) ? data[value] : data.other;
  }
  function reqArgs(keys, data) {
    for (var i = 0; i < keys.length; ++i) {
      if (!data || data[keys[i]] === undefined) throw new Error("Message requires argument '" + keys[i] + "'");
    }
  }

  var Runtime = /*#__PURE__*/Object.freeze({
    __proto__: null,
    _nf: _nf,
    number: number,
    strictNumber: strictNumber,
    plural: plural,
    select: select,
    reqArgs: reqArgs
  });

  function date(v, lc, p) {
    var o = {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    };

    switch (p) {
      case 'full':
        o.weekday = 'long';

      case 'long':
        o.month = 'long';
        break;

      case 'short':
        o.month = 'numeric';
    }

    return new Date(v).toLocaleDateString(lc, o);
  }

  function duration(value) {
    if (!isFinite(value)) return String(value);
    var sign = '';

    if (value < 0) {
      sign = '-';
      value = Math.abs(value);
    } else {
      value = Number(value);
    }

    var sec = value % 60;
    var parts = [Math.round(sec) === sec ? sec : sec.toFixed(3)];

    if (value < 60) {
      parts.unshift(0);
    } else {
      value = Math.round((value - parts[0]) / 60);
      parts.unshift(value % 60);

      if (value >= 60) {
        value = Math.round((value - parts[0]) / 60);
        parts.unshift(value);
      }
    }

    var first = parts.shift();
    return sign + first + ':' + parts.map(function (n) {
      return n < 10 ? '0' + String(n) : String(n);
    }).join(':');
  }

  function numberFmt(value, lc, arg, defaultCurrency) {
    var a = arg && arg.split(':') || [];
    var opt = {
      integer: {
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent'
      },
      currency: {
        style: 'currency',
        currency: a[1] && a[1].trim() || defaultCurrency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    };
    return new Intl.NumberFormat(lc, opt[a[0]] || {}).format(value);
  }
  function numberCurrency(value, lc, arg) {
    return new Intl.NumberFormat(lc, {
      style: 'currency',
      currency: arg,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }
  function numberInteger(value, lc) {
    return new Intl.NumberFormat(lc, {
      maximumFractionDigits: 0
    }).format(value);
  }
  function numberPercent(value, lc) {
    return new Intl.NumberFormat(lc, {
      style: 'percent'
    }).format(value);
  }

  function time(v, lc, p) {
    var o = {
      second: 'numeric',
      minute: 'numeric',
      hour: 'numeric'
    };

    switch (p) {
      case 'full':
      case 'long':
        o.timeZoneName = 'short';
        break;

      case 'short':
        delete o.second;
    }

    return new Date(v).toLocaleTimeString(lc, o);
  }

  var Formatters = /*#__PURE__*/Object.freeze({
    __proto__: null,
    date: date,
    duration: duration,
    numberCurrency: numberCurrency,
    numberFmt: numberFmt,
    numberInteger: numberInteger,
    numberPercent: numberPercent,
    time: time
  });

  var ES3 = {
    break: true,
    continue: true,
    delete: true,
    else: true,
    for: true,
    function: true,
    if: true,
    in: true,
    new: true,
    return: true,
    this: true,
    typeof: true,
    var: true,
    void: true,
    while: true,
    with: true,
    case: true,
    catch: true,
    default: true,
    do: true,
    finally: true,
    instanceof: true,
    switch: true,
    throw: true,
    try: true
  };
  var ESnext = {
    // in addition to reservedES3
    await: true,
    debugger: true,
    class: true,
    enum: true,
    extends: true,
    super: true,
    const: true,
    export: true,
    import: true,
    null: true,
    true: true,
    false: true,
    implements: true,
    let: true,
    private: true,
    public: true,
    yield: true,
    interface: true,
    package: true,
    protected: true,
    static: true
  };
  var reserved = {
    ES3: ES3,
    ESnext: ESnext
  };

  // from https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/


  function hashCode(str) {
    var hash = 0;

    for (var i = 0; i < str.length; ++i) {
      var char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash |= 0; // Convert to 32bit integer
    }

    return hash;
  }

  function identifier(key, unique) {
    if (unique) key += ' ' + hashCode(key).toString(36);
    var id = key.trim().replace(/\W+/g, '_');
    return reserved.ES3[id] || reserved.ESnext[id] || /^\d/.test(id) ? '_' + id : id;
  }

  function property(obj, key) {
    if (/^[A-Z_$][0-9A-Z_$]*$/i.test(key) && !reserved.ES3[key]) {
      return obj ? obj + '.' + key : key;
    } else {
      var jkey = JSON.stringify(key);
      return obj ? obj + '[' + jkey + ']' : jkey;
    }
  }

  var safeIdentifier = {
    identifier: identifier,
    property: property
  };
  var safeIdentifier_1 = safeIdentifier.identifier;
  var safeIdentifier_2 = safeIdentifier.property;

  var rtlLanguages = ['ar', 'ckb', 'fa', 'he', 'ks($|[^bfh])', 'lrc', 'mzn', 'pa-Arab', 'ps', 'ug', 'ur', 'uz-Arab', 'yi'];
  var rtlRegExp = new RegExp('^' + rtlLanguages.join('|^'));
  /**
   * Utility formatter function for enforcing Bidi Structured Text by using UCC
   *
   * List inlined from data extracted from CLDR v27 & v28
   * To verify/recreate, use the following:
   *
   *    git clone https://github.com/unicode-cldr/cldr-misc-full.git
   *    cd cldr-misc-full/main/
   *    grep characterOrder -r . | tr '"/' '\t' | cut -f2,6 | grep -C4 right-to-left
   *
   * @private
   */

  function biDiMarkText(text, locale) {
    var isLocaleRTL = rtlRegExp.test(locale);
    var mark = JSON.stringify(isLocaleRTL ? "\u200F" : "\u200E");
    return "".concat(mark, " + ").concat(text, " + ").concat(mark);
  }

  var RUNTIME_MODULE = 'messageformat-runtime';
  var CARDINAL_MODULE = 'messageformat-runtime/lib/cardinals';
  var PLURAL_MODULE = 'messageformat-runtime/lib/plurals';
  var FORMATTER_MODULE = 'messageformat-runtime/lib/formatters';

  var Compiler = /*#__PURE__*/function () {
    /** Creates a new message compiler. Called internally from {@link MessageFormat#compile}.
     *
     * @param {object} options - A MessageFormat options object
     * @property {object} locales - The locale identifiers that are used by the compiled functions
     * @property {object} runtime - Names of the core runtime functions that are used by the compiled functions
     * @property {object} formatters - The formatter functions that are used by the compiled functions
     */
    function Compiler(options) {
      _classCallCheck(this, Compiler);

      this.options = options;
      this.plural = null;
      this.runtime = {};
    }
    /** Recursively compile a string or a tree of strings to JavaScript function sources
     *
     *  If `src` is an object with a key that is also present in `plurals`, the key
     *  in question will be used as the locale identifier for its value. To disable
     *  the compile-time checks for plural & selectordinal keys while maintaining
     *  multi-locale support, use falsy values in `plurals`.
     *
     * @param {string|object} src - the source for which the JS code should be generated
     * @param {object} plural - the default locale
     * @param {object} plurals - a map of pluralization keys for all available locales
     */


    _createClass(Compiler, [{
      key: "compile",
      value: function compile(src, plural, plurals) {
        var _this = this;

        if (_typeof(src) === 'object') {
          var result = {};

          for (var _i = 0, _Object$keys = Object.keys(src); _i < _Object$keys.length; _i++) {
            var key = _Object$keys[_i];
            var pl = plurals[key] || plural;
            result[key] = this.compile(src[key], pl, plurals);
          }

          return result;
        }

        this.plural = plural;
        var parserOptions = {
          cardinal: plural.cardinals,
          ordinal: plural.ordinals,
          strict: this.options.strictNumberSign
        };
        this.arguments = [];
        var r = parser_1(src, parserOptions).map(function (token) {
          return _this.token(token);
        });
        var reqArgs = '';

        if (this.options.requireAllArguments && this.arguments.length > 0) {
          this.setRuntimeFn('reqArgs');
          reqArgs = "reqArgs(".concat(JSON.stringify(this.arguments), ", d); ");
        }

        return "function(d) { ".concat(reqArgs, "return ").concat(this.concatenate(r, true), "; }");
      }
    }, {
      key: "cases",
      value: function cases(token, pluralToken) {
        var _this2 = this;

        var needOther = true;
        var r = token.cases.map(function (_ref) {
          var key = _ref.key,
              tokens = _ref.tokens;
          if (key === 'other') needOther = false;
          var s = tokens.map(function (tok) {
            return _this2.token(tok, pluralToken);
          });
          return "".concat(safeIdentifier_2(null, key), ": ").concat(_this2.concatenate(s, false));
        });

        if (needOther) {
          var type = token.type;
          var _this$plural = this.plural,
              cardinals = _this$plural.cardinals,
              ordinals = _this$plural.ordinals;
          if (type === 'select' || type === 'plural' && cardinals.includes('other') || type === 'selectordinal' && ordinals.includes('other')) throw new Error("No 'other' form found in ".concat(JSON.stringify(token)));
        }

        return "{ ".concat(r.join(', '), " }");
      }
    }, {
      key: "concatenate",
      value: function concatenate(tokens, root) {
        var asValues = this.options.returnType === 'values';
        return asValues && (root || tokens.length > 1) ? '[' + tokens.join(', ') + ']' : tokens.join(' + ') || '""';
      }
    }, {
      key: "token",
      value: function token(_token, pluralToken) {
        var _this3 = this;

        if (typeof _token == 'string') return JSON.stringify(_token);
        var fn;
        this.arguments.push(_token.arg);
        var args = [safeIdentifier_2('d', _token.arg)];

        switch (_token.type) {
          case 'argument':
            return this.options.biDiSupport ? biDiMarkText(args[0], this.plural.id) : args[0];

          case 'select':
            fn = 'select';
            if (pluralToken && this.options.strictNumberSign) pluralToken = null;
            args.push(this.cases(_token, pluralToken));
            this.setRuntimeFn('select');
            break;

          case 'selectordinal':
            fn = 'plural';
            args.push(_token.offset || 0, safeIdentifier_1(this.plural.id), this.cases(_token, _token), 1);
            this.setLocale(this.plural.id, true);
            this.setRuntimeFn('plural');
            break;

          case 'plural':
            fn = 'plural';
            args.push(_token.offset || 0, safeIdentifier_1(this.plural.id), this.cases(_token, _token));
            this.setLocale(this.plural.id, false);
            this.setRuntimeFn('plural');
            break;

          case 'function':
            switch (_token.key) {
              case 'date':
                fn = this.setDateFormatter(_token, args, pluralToken);
                break;

              case 'number':
                fn = this.setNumberFormatter(_token, args, pluralToken);
                break;

              default:
                args.push(JSON.stringify(this.plural.locale));

                if (_token.param) {
                  if (pluralToken && this.options.strictNumberSign) pluralToken = null;

                  var s = _token.param.tokens.map(function (tok) {
                    return _this3.token(tok, pluralToken);
                  });

                  args.push('(' + (s.join(' + ') || '""') + ').trim()');
                  if (_token.key === 'number') args.push(JSON.stringify(this.options.currency));
                }

                fn = _token.key;
                this.setFormatter(fn);
            }

            break;

          case 'octothorpe':
            if (!pluralToken) return '"#"';
            args = [JSON.stringify(this.plural.locale), safeIdentifier_2('d', pluralToken.arg), pluralToken.offset || '0'];

            if (this.options.strictNumberSign) {
              fn = 'strictNumber';
              args.push(JSON.stringify(pluralToken.arg));
            } else {
              fn = 'number';
            }

            this.setRuntimeFn(fn);
            break;
        }

        if (!fn) throw new Error('Parser error for token ' + JSON.stringify(_token));
        return "".concat(fn, "(").concat(args.join(', '), ")");
      }
    }, {
      key: "runtimeIncludes",
      value: function runtimeIncludes(key, type) {
        var prev = this.runtime[key];
        if (!prev || prev.type === type) return prev;
        if (safeIdentifier_1(key) !== key) throw new SyntaxError("Reserved word used as ".concat(type, " identifier: ").concat(key));
        throw new TypeError("Cannot override ".concat(prev.type, " runtime function as ").concat(type, ": ").concat(key));
      }
    }, {
      key: "setLocale",
      value: function setLocale(key, ord) {
        var prev = this.runtimeIncludes(key, 'locale');
        var _this$plural2 = this.plural,
            getCardinal = _this$plural2.getCardinal,
            getPlural = _this$plural2.getPlural,
            isDefault = _this$plural2.isDefault;
        var pf;

        if (!ord && isDefault && getCardinal) {
          if (prev) return;

          pf = function pf(n) {
            return getCardinal(n);
          };

          pf.module = CARDINAL_MODULE;

          pf.toString = function () {
            return String(getCardinal);
          };
        } else {
          // overwrite a previous cardinal-only locale function
          if (prev && (!isDefault || prev.module === PLURAL_MODULE)) return;

          pf = function pf(n, ord) {
            return getPlural(n, ord);
          };

          pf.module = isDefault ? PLURAL_MODULE : getPlural.module;

          pf.toString = function () {
            return String(getPlural);
          };
        }

        pf.type = 'locale';
        this.runtime[key] = pf;
      }
    }, {
      key: "setRuntimeFn",
      value: function setRuntimeFn(key) {
        if (this.runtimeIncludes(key, 'runtime')) return;
        var rf = Runtime[key];
        rf.module = RUNTIME_MODULE;
        rf.type = 'runtime';
        this.runtime[key] = rf;
      }
    }, {
      key: "setFormatter",
      value: function setFormatter(key) {
        if (this.runtimeIncludes(key, 'formatter')) return;
        var cf = this.options.customFormatters[key];

        if (cf) {
          cf.type = 'formatter';
          this.runtime[key] = cf;
        } else {
          var df = Formatters[key];

          if (df) {
            df.module = FORMATTER_MODULE;
            df.type = 'formatter';
            this.runtime[key] = df;
          } else {
            throw new Error("Formatting function not found: ".concat(key));
          }
        }
      }
    }, {
      key: "setDateFormatter",
      value: function setDateFormatter(_ref2, args, plural) {
        var _this4 = this;

        var param = _ref2.param;
        var locale = this.plural.locale;
        var argStyle = param && param.tokens.length === 1 && param.tokens[0];

        if (typeof argStyle === 'string' && /^\s*::/.test(argStyle)) {
          var argSkeletonText = argStyle.trim().substr(2);
          var key = safeIdentifier_1("date_".concat(locale, "_").concat(argSkeletonText), true);

          if (!this.runtimeIncludes(key, 'formatter')) {
            var fmt = getDateFormatter(locale, argSkeletonText);

            fmt.toString = function () {
              return getDateFormatterSource(locale, argSkeletonText);
            };

            fmt.type = 'formatter';
            this.runtime[key] = fmt;
          }

          return key;
        }

        args.push(JSON.stringify(locale));

        if (param) {
          if (plural && this.options.strictNumberSign) plural = null;
          var s = param.tokens.map(function (tok) {
            return _this4.token(tok, plural);
          });
          args.push('(' + (s.join(' + ') || '""') + ').trim()');
        }

        this.setFormatter('date');
        return 'date';
      }
    }, {
      key: "setNumberFormatter",
      value: function setNumberFormatter(_ref3, args, plural) {
        var _this5 = this;

        var param = _ref3.param;
        var locale = this.plural.locale;

        if (!param) {
          // {var, number} can use runtime number(lc, var, offset)
          args.unshift(JSON.stringify(locale));
          args.push('0');
          this.setRuntimeFn('number');
          return 'number';
        }

        args.push(JSON.stringify(locale));

        if (param.tokens.length === 1 && typeof param.tokens[0] === 'string') {
          var fmtArg = param.tokens[0].trim();

          switch (fmtArg) {
            case 'currency':
              args.push(JSON.stringify(this.options.currency));
              this.setFormatter('numberCurrency');
              return 'numberCurrency';

            case 'integer':
              this.setFormatter('numberInteger');
              return 'numberInteger';

            case 'percent':
              this.setFormatter('numberPercent');
              return 'numberPercent';
          } // TODO: Deprecate


          var cm = fmtArg.match(/^currency:([A-Z]+)$/);

          if (cm) {
            args.push(JSON.stringify(cm[1]));
            this.setFormatter('numberCurrency');
            return 'numberCurrency';
          }

          var key = safeIdentifier_1("number_".concat(locale, "_").concat(fmtArg), true);

          if (!this.runtimeIncludes(key, 'formatter')) {
            var currency = this.options.currency;
            var fmt = getNumberFormatter(locale, fmtArg, currency);

            fmt.toString = function () {
              return getNumberFormatterSource(locale, fmtArg, currency);
            };

            fmt.type = 'formatter';
            this.runtime[key] = fmt;
          }

          return key;
        }

        if (plural && this.options.strictNumberSign) plural = null;
        var s = param.tokens.map(function (tok) {
          return _this5.token(tok, plural);
        });
        args.push('(' + (s.join(' + ') || '""') + ').trim()');
        args.push(JSON.stringify(this.options.currency));
        this.setFormatter('numberFmt');
        return 'numberFmt';
      }
    }]);

    return Compiler;
  }();

  function a(n) {
    return n == 1 ? 'one' : 'other';
  }

  function b(n) {
    return n == 0 || n == 1 ? 'one' : 'other';
  }

  function c(n) {
    return n >= 0 && n <= 1 ? 'one' : 'other';
  }

  function d(n) {
    var s = String(n).split('.'),
        v0 = !s[1];
    return n == 1 && v0 ? 'one' : 'other';
  }

  function e(n) {
    return 'other';
  }

  function f(n) {
    return n == 1 ? 'one' : n == 2 ? 'two' : 'other';
  }

  var _in = e;
  var af = a;
  var ak = b;
  var am = c;
  var an = a;
  function ar(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n100 >= 3 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 99 ? 'many' : 'other';
  }
  function ars(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n100 >= 3 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 99 ? 'many' : 'other';
  }
  var as = c;
  var asa = a;
  var ast = d;
  var az = a;
  function be(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);
    return n10 == 1 && n100 != 11 ? 'one' : n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14) ? 'few' : t0 && n10 == 0 || n10 >= 5 && n10 <= 9 || n100 >= 11 && n100 <= 14 ? 'many' : 'other';
  }
  var bem = a;
  var bez = a;
  var bg = a;
  var bho = b;
  var bm = e;
  var bn = c;
  var bo = e;
  function br(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2),
        n1000000 = t0 && s[0].slice(-6);
    return n10 == 1 && n100 != 11 && n100 != 71 && n100 != 91 ? 'one' : n10 == 2 && n100 != 12 && n100 != 72 && n100 != 92 ? 'two' : (n10 == 3 || n10 == 4 || n10 == 9) && (n100 < 10 || n100 > 19) && (n100 < 70 || n100 > 79) && (n100 < 90 || n100 > 99) ? 'few' : n != 0 && t0 && n1000000 == 0 ? 'many' : 'other';
  }
  var brx = a;
  function bs(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2),
        f10 = f.slice(-1),
        f100 = f.slice(-2);
    return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
  }
  var ca = d;
  var ce = a;
  function ceb(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        f10 = f.slice(-1);
    return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
  }
  var cgg = a;
  var chr = a;
  var ckb = a;
  function cs(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1];
    return n == 1 && v0 ? 'one' : i >= 2 && i <= 4 && v0 ? 'few' : !v0 ? 'many' : 'other';
  }
  function cy(n) {
    return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n == 3 ? 'few' : n == 6 ? 'many' : 'other';
  }
  function da(n) {
    var s = String(n).split('.'),
        i = s[0],
        t0 = Number(s[0]) == n;
    return n == 1 || !t0 && (i == 0 || i == 1) ? 'one' : 'other';
  }
  var de = d;
  function dsb(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i100 = i.slice(-2),
        f100 = f.slice(-2);
    return v0 && i100 == 1 || f100 == 1 ? 'one' : v0 && i100 == 2 || f100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || f100 == 3 || f100 == 4 ? 'few' : 'other';
  }
  var dv = a;
  var dz = e;
  var ee = a;
  var el = a;
  var en = d;
  var eo = a;
  var es = a;
  var et = d;
  var eu = a;
  var fa = c;
  function ff(n) {
    return n >= 0 && n < 2 ? 'one' : 'other';
  }
  var fi = d;
  function fil(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        f10 = f.slice(-1);
    return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
  }
  var fo = a;
  function fr(n) {
    return n >= 0 && n < 2 ? 'one' : 'other';
  }
  var fur = a;
  var fy = d;
  function ga(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n;
    return n == 1 ? 'one' : n == 2 ? 'two' : t0 && n >= 3 && n <= 6 ? 'few' : t0 && n >= 7 && n <= 10 ? 'many' : 'other';
  }
  function gd(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n;
    return n == 1 || n == 11 ? 'one' : n == 2 || n == 12 ? 'two' : t0 && n >= 3 && n <= 10 || t0 && n >= 13 && n <= 19 ? 'few' : 'other';
  }
  var gl = d;
  var gsw = a;
  var gu = c;
  var guw = b;
  function gv(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    return v0 && i10 == 1 ? 'one' : v0 && i10 == 2 ? 'two' : v0 && (i100 == 0 || i100 == 20 || i100 == 40 || i100 == 60 || i100 == 80) ? 'few' : !v0 ? 'many' : 'other';
  }
  var ha = a;
  var haw = a;
  function he(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1);
    return n == 1 && v0 ? 'one' : i == 2 && v0 ? 'two' : v0 && (n < 0 || n > 10) && t0 && n10 == 0 ? 'many' : 'other';
  }
  var hi = c;
  function hr(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2),
        f10 = f.slice(-1),
        f100 = f.slice(-2);
    return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
  }
  function hsb(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i100 = i.slice(-2),
        f100 = f.slice(-2);
    return v0 && i100 == 1 || f100 == 1 ? 'one' : v0 && i100 == 2 || f100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || f100 == 3 || f100 == 4 ? 'few' : 'other';
  }
  var hu = a;
  function hy(n) {
    return n >= 0 && n < 2 ? 'one' : 'other';
  }
  var ia = d;
  var id = e;
  var ig = e;
  var ii = e;
  var io = d;
  function is(n) {
    var s = String(n).split('.'),
        i = s[0],
        t0 = Number(s[0]) == n,
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    return t0 && i10 == 1 && i100 != 11 || !t0 ? 'one' : 'other';
  }
  var it = d;
  var iu = f;
  function iw(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1);
    return n == 1 && v0 ? 'one' : i == 2 && v0 ? 'two' : v0 && (n < 0 || n > 10) && t0 && n10 == 0 ? 'many' : 'other';
  }
  var ja = e;
  var jbo = e;
  var jgo = a;
  var ji = d;
  var jmc = a;
  var jv = e;
  var jw = e;
  var ka = a;
  function kab(n) {
    return n >= 0 && n < 2 ? 'one' : 'other';
  }
  var kaj = a;
  var kcg = a;
  var kde = e;
  var kea = e;
  var kk = a;
  var kkj = a;
  var kl = a;
  var km = e;
  var kn = c;
  var ko = e;
  var ks = a;
  var ksb = a;
  function ksh(n) {
    return n == 0 ? 'zero' : n == 1 ? 'one' : 'other';
  }
  var ku = a;
  function kw(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2),
        n1000 = t0 && s[0].slice(-3),
        n100000 = t0 && s[0].slice(-5),
        n1000000 = t0 && s[0].slice(-6);
    return n == 0 ? 'zero' : n == 1 ? 'one' : n100 == 2 || n100 == 22 || n100 == 42 || n100 == 62 || n100 == 82 || t0 && n1000 == 0 && (n100000 >= 1000 && n100000 <= 20000 || n100000 == 40000 || n100000 == 60000 || n100000 == 80000) || n != 0 && n1000000 == 100000 ? 'two' : n100 == 3 || n100 == 23 || n100 == 43 || n100 == 63 || n100 == 83 ? 'few' : n != 1 && (n100 == 1 || n100 == 21 || n100 == 41 || n100 == 61 || n100 == 81) ? 'many' : 'other';
  }
  var ky = a;
  function lag(n) {
    var s = String(n).split('.'),
        i = s[0];
    return n == 0 ? 'zero' : (i == 0 || i == 1) && n != 0 ? 'one' : 'other';
  }
  var lb = a;
  var lg = a;
  var lkt = e;
  var ln = b;
  var lo = e;
  function lt(n) {
    var s = String(n).split('.'),
        f = s[1] || '',
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);
    return n10 == 1 && (n100 < 11 || n100 > 19) ? 'one' : n10 >= 2 && n10 <= 9 && (n100 < 11 || n100 > 19) ? 'few' : f != 0 ? 'many' : 'other';
  }
  function lv(n) {
    var s = String(n).split('.'),
        f = s[1] || '',
        v = f.length,
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2),
        f100 = f.slice(-2),
        f10 = f.slice(-1);
    return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && f100 >= 11 && f100 <= 19 ? 'zero' : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? 'one' : 'other';
  }
  var mas = a;
  var mg = b;
  var mgo = a;
  function mk(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2),
        f10 = f.slice(-1),
        f100 = f.slice(-2);
    return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : 'other';
  }
  var ml = a;
  var mn = a;
  function mo(n) {
    var s = String(n).split('.'),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    return n == 1 && v0 ? 'one' : !v0 || n == 0 || n100 >= 2 && n100 <= 19 ? 'few' : 'other';
  }
  var mr = a;
  var ms = e;
  function mt(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    return n == 1 ? 'one' : n == 0 || n100 >= 2 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 19 ? 'many' : 'other';
  }
  var my = e;
  var nah = a;
  var naq = f;
  var nb = a;
  var nd = a;
  var ne = a;
  var nl = d;
  var nn = a;
  var nnh = a;
  var no = a;
  var nqo = e;
  var nr = a;
  var nso = b;
  var ny = a;
  var nyn = a;
  var om = a;
  var or = a;
  var os = a;
  var osa = e;
  var pa = b;
  var pap = a;
  function pl(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    return n == 1 && v0 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i != 1 && (i10 == 0 || i10 == 1) || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 12 && i100 <= 14 ? 'many' : 'other';
  }
  function prg(n) {
    var s = String(n).split('.'),
        f = s[1] || '',
        v = f.length,
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2),
        f100 = f.slice(-2),
        f10 = f.slice(-1);
    return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && f100 >= 11 && f100 <= 19 ? 'zero' : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? 'one' : 'other';
  }
  var ps = a;
  function pt(n) {
    var s = String(n).split('.'),
        i = s[0];
    return i == 0 || i == 1 ? 'one' : 'other';
  }
  var pt_PT = d;
  var rm = a;
  function ro(n) {
    var s = String(n).split('.'),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    return n == 1 && v0 ? 'one' : !v0 || n == 0 || n100 >= 2 && n100 <= 19 ? 'few' : 'other';
  }
  var rof = a;
  var root = e;
  function ru(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    return v0 && i10 == 1 && i100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i10 == 0 || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 11 && i100 <= 14 ? 'many' : 'other';
  }
  var rwk = a;
  var sah = e;
  var saq = a;
  var sc = d;
  var scn = d;
  var sd = a;
  var sdh = a;
  var se = f;
  var seh = a;
  var ses = e;
  var sg = e;
  function sh(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2),
        f10 = f.slice(-1),
        f100 = f.slice(-2);
    return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
  }
  function shi(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n;
    return n >= 0 && n <= 1 ? 'one' : t0 && n >= 2 && n <= 10 ? 'few' : 'other';
  }
  function si(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '';
    return n == 0 || n == 1 || i == 0 && f == 1 ? 'one' : 'other';
  }
  function sk(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1];
    return n == 1 && v0 ? 'one' : i >= 2 && i <= 4 && v0 ? 'few' : !v0 ? 'many' : 'other';
  }
  function sl(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i100 = i.slice(-2);
    return v0 && i100 == 1 ? 'one' : v0 && i100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || !v0 ? 'few' : 'other';
  }
  var sma = f;
  var smi = f;
  var smj = f;
  var smn = f;
  var sms = f;
  var sn = a;
  var so = a;
  var sq = a;
  function sr(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2),
        f10 = f.slice(-1),
        f100 = f.slice(-2);
    return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
  }
  var ss = a;
  var ssy = a;
  var st = a;
  var su = e;
  var sv = d;
  var sw = d;
  var syr = a;
  var ta = a;
  var te = a;
  var teo = a;
  var th = e;
  var ti = b;
  var tig = a;
  var tk = a;
  function tl(n) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        f10 = f.slice(-1);
    return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
  }
  var tn = a;
  var to = e;
  var tr = a;
  var ts = a;
  function tzm(n) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n;
    return n == 0 || n == 1 || t0 && n >= 11 && n <= 99 ? 'one' : 'other';
  }
  var ug = a;
  function uk(n) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    return v0 && i10 == 1 && i100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i10 == 0 || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 11 && i100 <= 14 ? 'many' : 'other';
  }
  var ur = d;
  var uz = a;
  var ve = a;
  var vi = e;
  var vo = a;
  var vun = a;
  var wa = b;
  var wae = a;
  var wo = e;
  var xh = a;
  var xog = a;
  var yi = d;
  var yo = e;
  var yue = e;
  var zh = e;
  var zu = c;

  var Cardinals = /*#__PURE__*/Object.freeze({
    __proto__: null,
    _in: _in,
    af: af,
    ak: ak,
    am: am,
    an: an,
    ar: ar,
    ars: ars,
    as: as,
    asa: asa,
    ast: ast,
    az: az,
    be: be,
    bem: bem,
    bez: bez,
    bg: bg,
    bho: bho,
    bm: bm,
    bn: bn,
    bo: bo,
    br: br,
    brx: brx,
    bs: bs,
    ca: ca,
    ce: ce,
    ceb: ceb,
    cgg: cgg,
    chr: chr,
    ckb: ckb,
    cs: cs,
    cy: cy,
    da: da,
    de: de,
    dsb: dsb,
    dv: dv,
    dz: dz,
    ee: ee,
    el: el,
    en: en,
    eo: eo,
    es: es,
    et: et,
    eu: eu,
    fa: fa,
    ff: ff,
    fi: fi,
    fil: fil,
    fo: fo,
    fr: fr,
    fur: fur,
    fy: fy,
    ga: ga,
    gd: gd,
    gl: gl,
    gsw: gsw,
    gu: gu,
    guw: guw,
    gv: gv,
    ha: ha,
    haw: haw,
    he: he,
    hi: hi,
    hr: hr,
    hsb: hsb,
    hu: hu,
    hy: hy,
    ia: ia,
    id: id,
    ig: ig,
    ii: ii,
    io: io,
    is: is,
    it: it,
    iu: iu,
    iw: iw,
    ja: ja,
    jbo: jbo,
    jgo: jgo,
    ji: ji,
    jmc: jmc,
    jv: jv,
    jw: jw,
    ka: ka,
    kab: kab,
    kaj: kaj,
    kcg: kcg,
    kde: kde,
    kea: kea,
    kk: kk,
    kkj: kkj,
    kl: kl,
    km: km,
    kn: kn,
    ko: ko,
    ks: ks,
    ksb: ksb,
    ksh: ksh,
    ku: ku,
    kw: kw,
    ky: ky,
    lag: lag,
    lb: lb,
    lg: lg,
    lkt: lkt,
    ln: ln,
    lo: lo,
    lt: lt,
    lv: lv,
    mas: mas,
    mg: mg,
    mgo: mgo,
    mk: mk,
    ml: ml,
    mn: mn,
    mo: mo,
    mr: mr,
    ms: ms,
    mt: mt,
    my: my,
    nah: nah,
    naq: naq,
    nb: nb,
    nd: nd,
    ne: ne,
    nl: nl,
    nn: nn,
    nnh: nnh,
    no: no,
    nqo: nqo,
    nr: nr,
    nso: nso,
    ny: ny,
    nyn: nyn,
    om: om,
    or: or,
    os: os,
    osa: osa,
    pa: pa,
    pap: pap,
    pl: pl,
    prg: prg,
    ps: ps,
    pt: pt,
    pt_PT: pt_PT,
    rm: rm,
    ro: ro,
    rof: rof,
    root: root,
    ru: ru,
    rwk: rwk,
    sah: sah,
    saq: saq,
    sc: sc,
    scn: scn,
    sd: sd,
    sdh: sdh,
    se: se,
    seh: seh,
    ses: ses,
    sg: sg,
    sh: sh,
    shi: shi,
    si: si,
    sk: sk,
    sl: sl,
    sma: sma,
    smi: smi,
    smj: smj,
    smn: smn,
    sms: sms,
    sn: sn,
    so: so,
    sq: sq,
    sr: sr,
    ss: ss,
    ssy: ssy,
    st: st,
    su: su,
    sv: sv,
    sw: sw,
    syr: syr,
    ta: ta,
    te: te,
    teo: teo,
    th: th,
    ti: ti,
    tig: tig,
    tk: tk,
    tl: tl,
    tn: tn,
    to: to,
    tr: tr,
    ts: ts,
    tzm: tzm,
    ug: ug,
    uk: uk,
    ur: ur,
    uz: uz,
    ve: ve,
    vi: vi,
    vo: vo,
    vun: vun,
    wa: wa,
    wae: wae,
    wo: wo,
    xh: xh,
    xog: xog,
    yi: yi,
    yo: yo,
    yue: yue,
    zh: zh,
    zu: zu
  });

  var z = "zero",
      o = "one",
      t = "two",
      f$1 = "few",
      m = "many",
      x = "other";
  var a$1 = {
    cardinal: [o, x],
    ordinal: [x]
  };
  var b$1 = {
    cardinal: [x],
    ordinal: [x]
  };
  var c$1 = {
    cardinal: [o, f$1, m, x],
    ordinal: [x]
  };
  var d$1 = {
    cardinal: [o, x],
    ordinal: [o, x]
  };
  var e$1 = {
    cardinal: [o, t, x],
    ordinal: [x]
  };
  var _in$1 = b$1;
  var af$1 = a$1;
  var ak$1 = a$1;
  var am$1 = a$1;
  var an$1 = a$1;
  var ar$1 = {
    cardinal: [z, o, t, f$1, m, x],
    ordinal: [x]
  };
  var ars$1 = {
    cardinal: [z, o, t, f$1, m, x],
    ordinal: [x]
  };
  var as$1 = {
    cardinal: [o, x],
    ordinal: [o, t, f$1, m, x]
  };
  var asa$1 = a$1;
  var ast$1 = a$1;
  var az$1 = {
    cardinal: [o, x],
    ordinal: [o, f$1, m, x]
  };
  var be$1 = {
    cardinal: [o, f$1, m, x],
    ordinal: [f$1, x]
  };
  var bem$1 = a$1;
  var bez$1 = a$1;
  var bg$1 = a$1;
  var bho$1 = a$1;
  var bm$1 = b$1;
  var bn$1 = {
    cardinal: [o, x],
    ordinal: [o, t, f$1, m, x]
  };
  var bo$1 = b$1;
  var br$1 = {
    cardinal: [o, t, f$1, m, x],
    ordinal: [x]
  };
  var brx$1 = a$1;
  var bs$1 = {
    cardinal: [o, f$1, x],
    ordinal: [x]
  };
  var ca$1 = {
    cardinal: [o, x],
    ordinal: [o, t, f$1, x]
  };
  var ce$1 = a$1;
  var ceb$1 = a$1;
  var cgg$1 = a$1;
  var chr$1 = a$1;
  var ckb$1 = a$1;
  var cs$1 = c$1;
  var cy$1 = {
    cardinal: [z, o, t, f$1, m, x],
    ordinal: [z, o, t, f$1, m, x]
  };
  var da$1 = a$1;
  var de$1 = a$1;
  var dsb$1 = {
    cardinal: [o, t, f$1, x],
    ordinal: [x]
  };
  var dv$1 = a$1;
  var dz$1 = b$1;
  var ee$1 = a$1;
  var el$1 = a$1;
  var en$1 = {
    cardinal: [o, x],
    ordinal: [o, t, f$1, x]
  };
  var eo$1 = a$1;
  var es$1 = a$1;
  var et$1 = a$1;
  var eu$1 = a$1;
  var fa$1 = a$1;
  var ff$1 = a$1;
  var fi$1 = a$1;
  var fil$1 = d$1;
  var fo$1 = a$1;
  var fr$1 = d$1;
  var fur$1 = a$1;
  var fy$1 = a$1;
  var ga$1 = {
    cardinal: [o, t, f$1, m, x],
    ordinal: [o, x]
  };
  var gd$1 = {
    cardinal: [o, t, f$1, x],
    ordinal: [o, t, f$1, x]
  };
  var gl$1 = a$1;
  var gsw$1 = a$1;
  var gu$1 = {
    cardinal: [o, x],
    ordinal: [o, t, f$1, m, x]
  };
  var guw$1 = a$1;
  var gv$1 = {
    cardinal: [o, t, f$1, m, x],
    ordinal: [x]
  };
  var ha$1 = a$1;
  var haw$1 = a$1;
  var he$1 = {
    cardinal: [o, t, m, x],
    ordinal: [x]
  };
  var hi$1 = {
    cardinal: [o, x],
    ordinal: [o, t, f$1, m, x]
  };
  var hr$1 = {
    cardinal: [o, f$1, x],
    ordinal: [x]
  };
  var hsb$1 = {
    cardinal: [o, t, f$1, x],
    ordinal: [x]
  };
  var hu$1 = d$1;
  var hy$1 = d$1;
  var ia$1 = a$1;
  var id$1 = b$1;
  var ig$1 = b$1;
  var ii$1 = b$1;
  var io$1 = a$1;
  var is$1 = a$1;
  var it$1 = {
    cardinal: [o, x],
    ordinal: [m, x]
  };
  var iu$1 = e$1;
  var iw$1 = {
    cardinal: [o, t, m, x],
    ordinal: [x]
  };
  var ja$1 = b$1;
  var jbo$1 = b$1;
  var jgo$1 = a$1;
  var ji$1 = a$1;
  var jmc$1 = a$1;
  var jv$1 = b$1;
  var jw$1 = b$1;
  var ka$1 = {
    cardinal: [o, x],
    ordinal: [o, m, x]
  };
  var kab$1 = a$1;
  var kaj$1 = a$1;
  var kcg$1 = a$1;
  var kde$1 = b$1;
  var kea$1 = b$1;
  var kk$1 = {
    cardinal: [o, x],
    ordinal: [m, x]
  };
  var kkj$1 = a$1;
  var kl$1 = a$1;
  var km$1 = b$1;
  var kn$1 = a$1;
  var ko$1 = b$1;
  var ks$1 = a$1;
  var ksb$1 = a$1;
  var ksh$1 = {
    cardinal: [z, o, x],
    ordinal: [x]
  };
  var ku$1 = a$1;
  var kw$1 = {
    cardinal: [z, o, t, f$1, m, x],
    ordinal: [o, m, x]
  };
  var ky$1 = a$1;
  var lag$1 = {
    cardinal: [z, o, x],
    ordinal: [x]
  };
  var lb$1 = a$1;
  var lg$1 = a$1;
  var lkt$1 = b$1;
  var ln$1 = a$1;
  var lo$1 = {
    cardinal: [x],
    ordinal: [o, x]
  };
  var lt$1 = c$1;
  var lv$1 = {
    cardinal: [z, o, x],
    ordinal: [x]
  };
  var mas$1 = a$1;
  var mg$1 = a$1;
  var mgo$1 = a$1;
  var mk$1 = {
    cardinal: [o, x],
    ordinal: [o, t, m, x]
  };
  var ml$1 = a$1;
  var mn$1 = a$1;
  var mo$1 = {
    cardinal: [o, f$1, x],
    ordinal: [o, x]
  };
  var mr$1 = {
    cardinal: [o, x],
    ordinal: [o, t, f$1, x]
  };
  var ms$1 = {
    cardinal: [x],
    ordinal: [o, x]
  };
  var mt$1 = c$1;
  var my$1 = b$1;
  var nah$1 = a$1;
  var naq$1 = e$1;
  var nb$1 = a$1;
  var nd$1 = a$1;
  var ne$1 = d$1;
  var nl$1 = a$1;
  var nn$1 = a$1;
  var nnh$1 = a$1;
  var no$1 = a$1;
  var nqo$1 = b$1;
  var nr$1 = a$1;
  var nso$1 = a$1;
  var ny$1 = a$1;
  var nyn$1 = a$1;
  var om$1 = a$1;
  var or$1 = {
    cardinal: [o, x],
    ordinal: [o, t, f$1, m, x]
  };
  var os$1 = a$1;
  var osa$1 = b$1;
  var pa$1 = a$1;
  var pap$1 = a$1;
  var pl$1 = c$1;
  var prg$1 = {
    cardinal: [z, o, x],
    ordinal: [x]
  };
  var ps$1 = a$1;
  var pt$1 = a$1;
  var pt_PT$1 = a$1;
  var rm$1 = a$1;
  var ro$1 = {
    cardinal: [o, f$1, x],
    ordinal: [o, x]
  };
  var rof$1 = a$1;
  var root$1 = b$1;
  var ru$1 = c$1;
  var rwk$1 = a$1;
  var sah$1 = b$1;
  var saq$1 = a$1;
  var sc$1 = {
    cardinal: [o, x],
    ordinal: [m, x]
  };
  var scn$1 = {
    cardinal: [o, x],
    ordinal: [m, x]
  };
  var sd$1 = a$1;
  var sdh$1 = a$1;
  var se$1 = e$1;
  var seh$1 = a$1;
  var ses$1 = b$1;
  var sg$1 = b$1;
  var sh$1 = {
    cardinal: [o, f$1, x],
    ordinal: [x]
  };
  var shi$1 = {
    cardinal: [o, f$1, x],
    ordinal: [x]
  };
  var si$1 = a$1;
  var sk$1 = c$1;
  var sl$1 = {
    cardinal: [o, t, f$1, x],
    ordinal: [x]
  };
  var sma$1 = e$1;
  var smi$1 = e$1;
  var smj$1 = e$1;
  var smn$1 = e$1;
  var sms$1 = e$1;
  var sn$1 = a$1;
  var so$1 = a$1;
  var sq$1 = {
    cardinal: [o, x],
    ordinal: [o, m, x]
  };
  var sr$1 = {
    cardinal: [o, f$1, x],
    ordinal: [x]
  };
  var ss$1 = a$1;
  var ssy$1 = a$1;
  var st$1 = a$1;
  var su$1 = b$1;
  var sv$1 = d$1;
  var sw$1 = a$1;
  var syr$1 = a$1;
  var ta$1 = a$1;
  var te$1 = a$1;
  var teo$1 = a$1;
  var th$1 = b$1;
  var ti$1 = a$1;
  var tig$1 = a$1;
  var tk$1 = {
    cardinal: [o, x],
    ordinal: [f$1, x]
  };
  var tl$1 = d$1;
  var tn$1 = a$1;
  var to$1 = b$1;
  var tr$1 = a$1;
  var ts$1 = a$1;
  var tzm$1 = a$1;
  var ug$1 = a$1;
  var uk$1 = {
    cardinal: [o, f$1, m, x],
    ordinal: [f$1, x]
  };
  var ur$1 = a$1;
  var uz$1 = a$1;
  var ve$1 = a$1;
  var vi$1 = {
    cardinal: [x],
    ordinal: [o, x]
  };
  var vo$1 = a$1;
  var vun$1 = a$1;
  var wa$1 = a$1;
  var wae$1 = a$1;
  var wo$1 = b$1;
  var xh$1 = a$1;
  var xog$1 = a$1;
  var yi$1 = a$1;
  var yo$1 = b$1;
  var yue$1 = b$1;
  var zh$1 = b$1;
  var zu$1 = a$1;

  var PluralCategories = /*#__PURE__*/Object.freeze({
    __proto__: null,
    _in: _in$1,
    af: af$1,
    ak: ak$1,
    am: am$1,
    an: an$1,
    ar: ar$1,
    ars: ars$1,
    as: as$1,
    asa: asa$1,
    ast: ast$1,
    az: az$1,
    be: be$1,
    bem: bem$1,
    bez: bez$1,
    bg: bg$1,
    bho: bho$1,
    bm: bm$1,
    bn: bn$1,
    bo: bo$1,
    br: br$1,
    brx: brx$1,
    bs: bs$1,
    ca: ca$1,
    ce: ce$1,
    ceb: ceb$1,
    cgg: cgg$1,
    chr: chr$1,
    ckb: ckb$1,
    cs: cs$1,
    cy: cy$1,
    da: da$1,
    de: de$1,
    dsb: dsb$1,
    dv: dv$1,
    dz: dz$1,
    ee: ee$1,
    el: el$1,
    en: en$1,
    eo: eo$1,
    es: es$1,
    et: et$1,
    eu: eu$1,
    fa: fa$1,
    ff: ff$1,
    fi: fi$1,
    fil: fil$1,
    fo: fo$1,
    fr: fr$1,
    fur: fur$1,
    fy: fy$1,
    ga: ga$1,
    gd: gd$1,
    gl: gl$1,
    gsw: gsw$1,
    gu: gu$1,
    guw: guw$1,
    gv: gv$1,
    ha: ha$1,
    haw: haw$1,
    he: he$1,
    hi: hi$1,
    hr: hr$1,
    hsb: hsb$1,
    hu: hu$1,
    hy: hy$1,
    ia: ia$1,
    id: id$1,
    ig: ig$1,
    ii: ii$1,
    io: io$1,
    is: is$1,
    it: it$1,
    iu: iu$1,
    iw: iw$1,
    ja: ja$1,
    jbo: jbo$1,
    jgo: jgo$1,
    ji: ji$1,
    jmc: jmc$1,
    jv: jv$1,
    jw: jw$1,
    ka: ka$1,
    kab: kab$1,
    kaj: kaj$1,
    kcg: kcg$1,
    kde: kde$1,
    kea: kea$1,
    kk: kk$1,
    kkj: kkj$1,
    kl: kl$1,
    km: km$1,
    kn: kn$1,
    ko: ko$1,
    ks: ks$1,
    ksb: ksb$1,
    ksh: ksh$1,
    ku: ku$1,
    kw: kw$1,
    ky: ky$1,
    lag: lag$1,
    lb: lb$1,
    lg: lg$1,
    lkt: lkt$1,
    ln: ln$1,
    lo: lo$1,
    lt: lt$1,
    lv: lv$1,
    mas: mas$1,
    mg: mg$1,
    mgo: mgo$1,
    mk: mk$1,
    ml: ml$1,
    mn: mn$1,
    mo: mo$1,
    mr: mr$1,
    ms: ms$1,
    mt: mt$1,
    my: my$1,
    nah: nah$1,
    naq: naq$1,
    nb: nb$1,
    nd: nd$1,
    ne: ne$1,
    nl: nl$1,
    nn: nn$1,
    nnh: nnh$1,
    no: no$1,
    nqo: nqo$1,
    nr: nr$1,
    nso: nso$1,
    ny: ny$1,
    nyn: nyn$1,
    om: om$1,
    or: or$1,
    os: os$1,
    osa: osa$1,
    pa: pa$1,
    pap: pap$1,
    pl: pl$1,
    prg: prg$1,
    ps: ps$1,
    pt: pt$1,
    pt_PT: pt_PT$1,
    rm: rm$1,
    ro: ro$1,
    rof: rof$1,
    root: root$1,
    ru: ru$1,
    rwk: rwk$1,
    sah: sah$1,
    saq: saq$1,
    sc: sc$1,
    scn: scn$1,
    sd: sd$1,
    sdh: sdh$1,
    se: se$1,
    seh: seh$1,
    ses: ses$1,
    sg: sg$1,
    sh: sh$1,
    shi: shi$1,
    si: si$1,
    sk: sk$1,
    sl: sl$1,
    sma: sma$1,
    smi: smi$1,
    smj: smj$1,
    smn: smn$1,
    sms: sms$1,
    sn: sn$1,
    so: so$1,
    sq: sq$1,
    sr: sr$1,
    ss: ss$1,
    ssy: ssy$1,
    st: st$1,
    su: su$1,
    sv: sv$1,
    sw: sw$1,
    syr: syr$1,
    ta: ta$1,
    te: te$1,
    teo: teo$1,
    th: th$1,
    ti: ti$1,
    tig: tig$1,
    tk: tk$1,
    tl: tl$1,
    tn: tn$1,
    to: to$1,
    tr: tr$1,
    ts: ts$1,
    tzm: tzm$1,
    ug: ug$1,
    uk: uk$1,
    ur: ur$1,
    uz: uz$1,
    ve: ve$1,
    vi: vi$1,
    vo: vo$1,
    vun: vun$1,
    wa: wa$1,
    wae: wae$1,
    wo: wo$1,
    xh: xh$1,
    xog: xog$1,
    yi: yi$1,
    yo: yo$1,
    yue: yue$1,
    zh: zh$1,
    zu: zu$1
  });

  function a$2(n, ord) {
    if (ord) return 'other';
    return n == 1 ? 'one' : 'other';
  }

  function b$2(n, ord) {
    if (ord) return 'other';
    return n == 0 || n == 1 ? 'one' : 'other';
  }

  function c$2(n, ord) {
    var s = String(n).split('.'),
        v0 = !s[1];
    if (ord) return 'other';
    return n == 1 && v0 ? 'one' : 'other';
  }

  function d$2(n, ord) {
    return 'other';
  }

  function e$2(n, ord) {
    if (ord) return 'other';
    return n == 1 ? 'one' : n == 2 ? 'two' : 'other';
  }

  var _in$2 = d$2;
  var af$2 = a$2;
  var ak$2 = b$2;
  function am$2(n, ord) {
    if (ord) return 'other';
    return n >= 0 && n <= 1 ? 'one' : 'other';
  }
  var an$2 = a$2;
  function ar$2(n, ord) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    if (ord) return 'other';
    return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n100 >= 3 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 99 ? 'many' : 'other';
  }
  function ars$2(n, ord) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    if (ord) return 'other';
    return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n100 >= 3 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 99 ? 'many' : 'other';
  }
  function as$2(n, ord) {
    if (ord) return n == 1 || n == 5 || n == 7 || n == 8 || n == 9 || n == 10 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : n == 6 ? 'many' : 'other';
    return n >= 0 && n <= 1 ? 'one' : 'other';
  }
  var asa$2 = a$2;
  var ast$2 = c$2;
  function az$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        i10 = i.slice(-1),
        i100 = i.slice(-2),
        i1000 = i.slice(-3);
    if (ord) return i10 == 1 || i10 == 2 || i10 == 5 || i10 == 7 || i10 == 8 || i100 == 20 || i100 == 50 || i100 == 70 || i100 == 80 ? 'one' : i10 == 3 || i10 == 4 || i1000 == 100 || i1000 == 200 || i1000 == 300 || i1000 == 400 || i1000 == 500 || i1000 == 600 || i1000 == 700 || i1000 == 800 || i1000 == 900 ? 'few' : i == 0 || i10 == 6 || i100 == 40 || i100 == 60 || i100 == 90 ? 'many' : 'other';
    return n == 1 ? 'one' : 'other';
  }
  function be$2(n, ord) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);
    if (ord) return (n10 == 2 || n10 == 3) && n100 != 12 && n100 != 13 ? 'few' : 'other';
    return n10 == 1 && n100 != 11 ? 'one' : n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14) ? 'few' : t0 && n10 == 0 || n10 >= 5 && n10 <= 9 || n100 >= 11 && n100 <= 14 ? 'many' : 'other';
  }
  var bem$2 = a$2;
  var bez$2 = a$2;
  var bg$2 = a$2;
  var bho$2 = b$2;
  var bm$2 = d$2;
  function bn$2(n, ord) {
    if (ord) return n == 1 || n == 5 || n == 7 || n == 8 || n == 9 || n == 10 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : n == 6 ? 'many' : 'other';
    return n >= 0 && n <= 1 ? 'one' : 'other';
  }
  var bo$2 = d$2;
  function br$2(n, ord) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2),
        n1000000 = t0 && s[0].slice(-6);
    if (ord) return 'other';
    return n10 == 1 && n100 != 11 && n100 != 71 && n100 != 91 ? 'one' : n10 == 2 && n100 != 12 && n100 != 72 && n100 != 92 ? 'two' : (n10 == 3 || n10 == 4 || n10 == 9) && (n100 < 10 || n100 > 19) && (n100 < 70 || n100 > 79) && (n100 < 90 || n100 > 99) ? 'few' : n != 0 && t0 && n1000000 == 0 ? 'many' : 'other';
  }
  var brx$2 = a$2;
  function bs$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2),
        f10 = f.slice(-1),
        f100 = f.slice(-2);
    if (ord) return 'other';
    return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
  }
  function ca$2(n, ord) {
    var s = String(n).split('.'),
        v0 = !s[1];
    if (ord) return n == 1 || n == 3 ? 'one' : n == 2 ? 'two' : n == 4 ? 'few' : 'other';
    return n == 1 && v0 ? 'one' : 'other';
  }
  var ce$2 = a$2;
  function ceb$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        f10 = f.slice(-1);
    if (ord) return 'other';
    return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
  }
  var cgg$2 = a$2;
  var chr$2 = a$2;
  var ckb$2 = a$2;
  function cs$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1];
    if (ord) return 'other';
    return n == 1 && v0 ? 'one' : i >= 2 && i <= 4 && v0 ? 'few' : !v0 ? 'many' : 'other';
  }
  function cy$2(n, ord) {
    if (ord) return n == 0 || n == 7 || n == 8 || n == 9 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n == 3 || n == 4 ? 'few' : n == 5 || n == 6 ? 'many' : 'other';
    return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n == 3 ? 'few' : n == 6 ? 'many' : 'other';
  }
  function da$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        t0 = Number(s[0]) == n;
    if (ord) return 'other';
    return n == 1 || !t0 && (i == 0 || i == 1) ? 'one' : 'other';
  }
  var de$2 = c$2;
  function dsb$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i100 = i.slice(-2),
        f100 = f.slice(-2);
    if (ord) return 'other';
    return v0 && i100 == 1 || f100 == 1 ? 'one' : v0 && i100 == 2 || f100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || f100 == 3 || f100 == 4 ? 'few' : 'other';
  }
  var dv$2 = a$2;
  var dz$2 = d$2;
  var ee$2 = a$2;
  var el$2 = a$2;
  function en$2(n, ord) {
    var s = String(n).split('.'),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);
    if (ord) return n10 == 1 && n100 != 11 ? 'one' : n10 == 2 && n100 != 12 ? 'two' : n10 == 3 && n100 != 13 ? 'few' : 'other';
    return n == 1 && v0 ? 'one' : 'other';
  }
  var eo$2 = a$2;
  var es$2 = a$2;
  var et$2 = c$2;
  var eu$2 = a$2;
  function fa$2(n, ord) {
    if (ord) return 'other';
    return n >= 0 && n <= 1 ? 'one' : 'other';
  }
  function ff$2(n, ord) {
    if (ord) return 'other';
    return n >= 0 && n < 2 ? 'one' : 'other';
  }
  var fi$2 = c$2;
  function fil$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        f10 = f.slice(-1);
    if (ord) return n == 1 ? 'one' : 'other';
    return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
  }
  var fo$2 = a$2;
  function fr$2(n, ord) {
    if (ord) return n == 1 ? 'one' : 'other';
    return n >= 0 && n < 2 ? 'one' : 'other';
  }
  var fur$2 = a$2;
  var fy$2 = c$2;
  function ga$2(n, ord) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n;
    if (ord) return n == 1 ? 'one' : 'other';
    return n == 1 ? 'one' : n == 2 ? 'two' : t0 && n >= 3 && n <= 6 ? 'few' : t0 && n >= 7 && n <= 10 ? 'many' : 'other';
  }
  function gd$2(n, ord) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n;
    if (ord) return n == 1 || n == 11 ? 'one' : n == 2 || n == 12 ? 'two' : n == 3 || n == 13 ? 'few' : 'other';
    return n == 1 || n == 11 ? 'one' : n == 2 || n == 12 ? 'two' : t0 && n >= 3 && n <= 10 || t0 && n >= 13 && n <= 19 ? 'few' : 'other';
  }
  var gl$2 = c$2;
  var gsw$2 = a$2;
  function gu$2(n, ord) {
    if (ord) return n == 1 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : n == 6 ? 'many' : 'other';
    return n >= 0 && n <= 1 ? 'one' : 'other';
  }
  var guw$2 = b$2;
  function gv$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    if (ord) return 'other';
    return v0 && i10 == 1 ? 'one' : v0 && i10 == 2 ? 'two' : v0 && (i100 == 0 || i100 == 20 || i100 == 40 || i100 == 60 || i100 == 80) ? 'few' : !v0 ? 'many' : 'other';
  }
  var ha$2 = a$2;
  var haw$2 = a$2;
  function he$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1);
    if (ord) return 'other';
    return n == 1 && v0 ? 'one' : i == 2 && v0 ? 'two' : v0 && (n < 0 || n > 10) && t0 && n10 == 0 ? 'many' : 'other';
  }
  function hi$2(n, ord) {
    if (ord) return n == 1 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : n == 6 ? 'many' : 'other';
    return n >= 0 && n <= 1 ? 'one' : 'other';
  }
  function hr$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2),
        f10 = f.slice(-1),
        f100 = f.slice(-2);
    if (ord) return 'other';
    return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
  }
  function hsb$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i100 = i.slice(-2),
        f100 = f.slice(-2);
    if (ord) return 'other';
    return v0 && i100 == 1 || f100 == 1 ? 'one' : v0 && i100 == 2 || f100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || f100 == 3 || f100 == 4 ? 'few' : 'other';
  }
  function hu$2(n, ord) {
    if (ord) return n == 1 || n == 5 ? 'one' : 'other';
    return n == 1 ? 'one' : 'other';
  }
  function hy$2(n, ord) {
    if (ord) return n == 1 ? 'one' : 'other';
    return n >= 0 && n < 2 ? 'one' : 'other';
  }
  var ia$2 = c$2;
  var id$2 = d$2;
  var ig$2 = d$2;
  var ii$2 = d$2;
  var io$2 = c$2;
  function is$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        t0 = Number(s[0]) == n,
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    if (ord) return 'other';
    return t0 && i10 == 1 && i100 != 11 || !t0 ? 'one' : 'other';
  }
  function it$2(n, ord) {
    var s = String(n).split('.'),
        v0 = !s[1];
    if (ord) return n == 11 || n == 8 || n == 80 || n == 800 ? 'many' : 'other';
    return n == 1 && v0 ? 'one' : 'other';
  }
  var iu$2 = e$2;
  function iw$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1);
    if (ord) return 'other';
    return n == 1 && v0 ? 'one' : i == 2 && v0 ? 'two' : v0 && (n < 0 || n > 10) && t0 && n10 == 0 ? 'many' : 'other';
  }
  var ja$2 = d$2;
  var jbo$2 = d$2;
  var jgo$2 = a$2;
  var ji$2 = c$2;
  var jmc$2 = a$2;
  var jv$2 = d$2;
  var jw$2 = d$2;
  function ka$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        i100 = i.slice(-2);
    if (ord) return i == 1 ? 'one' : i == 0 || i100 >= 2 && i100 <= 20 || i100 == 40 || i100 == 60 || i100 == 80 ? 'many' : 'other';
    return n == 1 ? 'one' : 'other';
  }
  function kab$2(n, ord) {
    if (ord) return 'other';
    return n >= 0 && n < 2 ? 'one' : 'other';
  }
  var kaj$2 = a$2;
  var kcg$2 = a$2;
  var kde$2 = d$2;
  var kea$2 = d$2;
  function kk$2(n, ord) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1);
    if (ord) return n10 == 6 || n10 == 9 || t0 && n10 == 0 && n != 0 ? 'many' : 'other';
    return n == 1 ? 'one' : 'other';
  }
  var kkj$2 = a$2;
  var kl$2 = a$2;
  var km$2 = d$2;
  function kn$2(n, ord) {
    if (ord) return 'other';
    return n >= 0 && n <= 1 ? 'one' : 'other';
  }
  var ko$2 = d$2;
  var ks$2 = a$2;
  var ksb$2 = a$2;
  function ksh$2(n, ord) {
    if (ord) return 'other';
    return n == 0 ? 'zero' : n == 1 ? 'one' : 'other';
  }
  var ku$2 = a$2;
  function kw$2(n, ord) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2),
        n1000 = t0 && s[0].slice(-3),
        n100000 = t0 && s[0].slice(-5),
        n1000000 = t0 && s[0].slice(-6);
    if (ord) return t0 && n >= 1 && n <= 4 || n100 >= 1 && n100 <= 4 || n100 >= 21 && n100 <= 24 || n100 >= 41 && n100 <= 44 || n100 >= 61 && n100 <= 64 || n100 >= 81 && n100 <= 84 ? 'one' : n == 5 || n100 == 5 ? 'many' : 'other';
    return n == 0 ? 'zero' : n == 1 ? 'one' : n100 == 2 || n100 == 22 || n100 == 42 || n100 == 62 || n100 == 82 || t0 && n1000 == 0 && (n100000 >= 1000 && n100000 <= 20000 || n100000 == 40000 || n100000 == 60000 || n100000 == 80000) || n != 0 && n1000000 == 100000 ? 'two' : n100 == 3 || n100 == 23 || n100 == 43 || n100 == 63 || n100 == 83 ? 'few' : n != 1 && (n100 == 1 || n100 == 21 || n100 == 41 || n100 == 61 || n100 == 81) ? 'many' : 'other';
  }
  var ky$2 = a$2;
  function lag$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0];
    if (ord) return 'other';
    return n == 0 ? 'zero' : (i == 0 || i == 1) && n != 0 ? 'one' : 'other';
  }
  var lb$2 = a$2;
  var lg$2 = a$2;
  var lkt$2 = d$2;
  var ln$2 = b$2;
  function lo$2(n, ord) {
    if (ord) return n == 1 ? 'one' : 'other';
    return 'other';
  }
  function lt$2(n, ord) {
    var s = String(n).split('.'),
        f = s[1] || '',
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);
    if (ord) return 'other';
    return n10 == 1 && (n100 < 11 || n100 > 19) ? 'one' : n10 >= 2 && n10 <= 9 && (n100 < 11 || n100 > 19) ? 'few' : f != 0 ? 'many' : 'other';
  }
  function lv$2(n, ord) {
    var s = String(n).split('.'),
        f = s[1] || '',
        v = f.length,
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2),
        f100 = f.slice(-2),
        f10 = f.slice(-1);
    if (ord) return 'other';
    return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && f100 >= 11 && f100 <= 19 ? 'zero' : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? 'one' : 'other';
  }
  var mas$2 = a$2;
  var mg$2 = b$2;
  var mgo$2 = a$2;
  function mk$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2),
        f10 = f.slice(-1),
        f100 = f.slice(-2);
    if (ord) return i10 == 1 && i100 != 11 ? 'one' : i10 == 2 && i100 != 12 ? 'two' : (i10 == 7 || i10 == 8) && i100 != 17 && i100 != 18 ? 'many' : 'other';
    return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : 'other';
  }
  var ml$2 = a$2;
  var mn$2 = a$2;
  function mo$2(n, ord) {
    var s = String(n).split('.'),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    if (ord) return n == 1 ? 'one' : 'other';
    return n == 1 && v0 ? 'one' : !v0 || n == 0 || n100 >= 2 && n100 <= 19 ? 'few' : 'other';
  }
  function mr$2(n, ord) {
    if (ord) return n == 1 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : 'other';
    return n == 1 ? 'one' : 'other';
  }
  function ms$2(n, ord) {
    if (ord) return n == 1 ? 'one' : 'other';
    return 'other';
  }
  function mt$2(n, ord) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    if (ord) return 'other';
    return n == 1 ? 'one' : n == 0 || n100 >= 2 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 19 ? 'many' : 'other';
  }
  var my$2 = d$2;
  var nah$2 = a$2;
  var naq$2 = e$2;
  var nb$2 = a$2;
  var nd$2 = a$2;
  function ne$2(n, ord) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n;
    if (ord) return t0 && n >= 1 && n <= 4 ? 'one' : 'other';
    return n == 1 ? 'one' : 'other';
  }
  var nl$2 = c$2;
  var nn$2 = a$2;
  var nnh$2 = a$2;
  var no$2 = a$2;
  var nqo$2 = d$2;
  var nr$2 = a$2;
  var nso$2 = b$2;
  var ny$2 = a$2;
  var nyn$2 = a$2;
  var om$2 = a$2;
  function or$2(n, ord) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n;
    if (ord) return n == 1 || n == 5 || t0 && n >= 7 && n <= 9 ? 'one' : n == 2 || n == 3 ? 'two' : n == 4 ? 'few' : n == 6 ? 'many' : 'other';
    return n == 1 ? 'one' : 'other';
  }
  var os$2 = a$2;
  var osa$2 = d$2;
  var pa$2 = b$2;
  var pap$2 = a$2;
  function pl$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    if (ord) return 'other';
    return n == 1 && v0 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i != 1 && (i10 == 0 || i10 == 1) || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 12 && i100 <= 14 ? 'many' : 'other';
  }
  function prg$2(n, ord) {
    var s = String(n).split('.'),
        f = s[1] || '',
        v = f.length,
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2),
        f100 = f.slice(-2),
        f10 = f.slice(-1);
    if (ord) return 'other';
    return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && f100 >= 11 && f100 <= 19 ? 'zero' : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? 'one' : 'other';
  }
  var ps$2 = a$2;
  function pt$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0];
    if (ord) return 'other';
    return i == 0 || i == 1 ? 'one' : 'other';
  }
  var pt_PT$2 = c$2;
  var rm$2 = a$2;
  function ro$2(n, ord) {
    var s = String(n).split('.'),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n100 = t0 && s[0].slice(-2);
    if (ord) return n == 1 ? 'one' : 'other';
    return n == 1 && v0 ? 'one' : !v0 || n == 0 || n100 >= 2 && n100 <= 19 ? 'few' : 'other';
  }
  var rof$2 = a$2;
  var root$2 = d$2;
  function ru$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    if (ord) return 'other';
    return v0 && i10 == 1 && i100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i10 == 0 || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 11 && i100 <= 14 ? 'many' : 'other';
  }
  var rwk$2 = a$2;
  var sah$2 = d$2;
  var saq$2 = a$2;
  function sc$2(n, ord) {
    var s = String(n).split('.'),
        v0 = !s[1];
    if (ord) return n == 11 || n == 8 || n == 80 || n == 800 ? 'many' : 'other';
    return n == 1 && v0 ? 'one' : 'other';
  }
  function scn$2(n, ord) {
    var s = String(n).split('.'),
        v0 = !s[1];
    if (ord) return n == 11 || n == 8 || n == 80 || n == 800 ? 'many' : 'other';
    return n == 1 && v0 ? 'one' : 'other';
  }
  var sd$2 = a$2;
  var sdh$2 = a$2;
  var se$2 = e$2;
  var seh$2 = a$2;
  var ses$2 = d$2;
  var sg$2 = d$2;
  function sh$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2),
        f10 = f.slice(-1),
        f100 = f.slice(-2);
    if (ord) return 'other';
    return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
  }
  function shi$2(n, ord) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n;
    if (ord) return 'other';
    return n >= 0 && n <= 1 ? 'one' : t0 && n >= 2 && n <= 10 ? 'few' : 'other';
  }
  function si$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '';
    if (ord) return 'other';
    return n == 0 || n == 1 || i == 0 && f == 1 ? 'one' : 'other';
  }
  function sk$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1];
    if (ord) return 'other';
    return n == 1 && v0 ? 'one' : i >= 2 && i <= 4 && v0 ? 'few' : !v0 ? 'many' : 'other';
  }
  function sl$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        i100 = i.slice(-2);
    if (ord) return 'other';
    return v0 && i100 == 1 ? 'one' : v0 && i100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || !v0 ? 'few' : 'other';
  }
  var sma$2 = e$2;
  var smi$2 = e$2;
  var smj$2 = e$2;
  var smn$2 = e$2;
  var sms$2 = e$2;
  var sn$2 = a$2;
  var so$2 = a$2;
  function sq$2(n, ord) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);
    if (ord) return n == 1 ? 'one' : n10 == 4 && n100 != 14 ? 'many' : 'other';
    return n == 1 ? 'one' : 'other';
  }
  function sr$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        i100 = i.slice(-2),
        f10 = f.slice(-1),
        f100 = f.slice(-2);
    if (ord) return 'other';
    return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
  }
  var ss$2 = a$2;
  var ssy$2 = a$2;
  var st$2 = a$2;
  var su$2 = d$2;
  function sv$2(n, ord) {
    var s = String(n).split('.'),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);
    if (ord) return (n10 == 1 || n10 == 2) && n100 != 11 && n100 != 12 ? 'one' : 'other';
    return n == 1 && v0 ? 'one' : 'other';
  }
  var sw$2 = c$2;
  var syr$2 = a$2;
  var ta$2 = a$2;
  var te$2 = a$2;
  var teo$2 = a$2;
  var th$2 = d$2;
  var ti$2 = b$2;
  var tig$2 = a$2;
  function tk$2(n, ord) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1);
    if (ord) return n10 == 6 || n10 == 9 || n == 10 ? 'few' : 'other';
    return n == 1 ? 'one' : 'other';
  }
  function tl$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        f = s[1] || '',
        v0 = !s[1],
        i10 = i.slice(-1),
        f10 = f.slice(-1);
    if (ord) return n == 1 ? 'one' : 'other';
    return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
  }
  var tn$2 = a$2;
  var to$2 = d$2;
  var tr$2 = a$2;
  var ts$2 = a$2;
  function tzm$2(n, ord) {
    var s = String(n).split('.'),
        t0 = Number(s[0]) == n;
    if (ord) return 'other';
    return n == 0 || n == 1 || t0 && n >= 11 && n <= 99 ? 'one' : 'other';
  }
  var ug$2 = a$2;
  function uk$2(n, ord) {
    var s = String(n).split('.'),
        i = s[0],
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2),
        i10 = i.slice(-1),
        i100 = i.slice(-2);
    if (ord) return n10 == 3 && n100 != 13 ? 'few' : 'other';
    return v0 && i10 == 1 && i100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i10 == 0 || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 11 && i100 <= 14 ? 'many' : 'other';
  }
  var ur$2 = c$2;
  var uz$2 = a$2;
  var ve$2 = a$2;
  function vi$2(n, ord) {
    if (ord) return n == 1 ? 'one' : 'other';
    return 'other';
  }
  var vo$2 = a$2;
  var vun$2 = a$2;
  var wa$2 = b$2;
  var wae$2 = a$2;
  var wo$2 = d$2;
  var xh$2 = a$2;
  var xog$2 = a$2;
  var yi$2 = c$2;
  var yo$2 = d$2;
  var yue$2 = d$2;
  var zh$2 = d$2;
  function zu$2(n, ord) {
    if (ord) return 'other';
    return n >= 0 && n <= 1 ? 'one' : 'other';
  }

  var Plurals = /*#__PURE__*/Object.freeze({
    __proto__: null,
    _in: _in$2,
    af: af$2,
    ak: ak$2,
    am: am$2,
    an: an$2,
    ar: ar$2,
    ars: ars$2,
    as: as$2,
    asa: asa$2,
    ast: ast$2,
    az: az$2,
    be: be$2,
    bem: bem$2,
    bez: bez$2,
    bg: bg$2,
    bho: bho$2,
    bm: bm$2,
    bn: bn$2,
    bo: bo$2,
    br: br$2,
    brx: brx$2,
    bs: bs$2,
    ca: ca$2,
    ce: ce$2,
    ceb: ceb$2,
    cgg: cgg$2,
    chr: chr$2,
    ckb: ckb$2,
    cs: cs$2,
    cy: cy$2,
    da: da$2,
    de: de$2,
    dsb: dsb$2,
    dv: dv$2,
    dz: dz$2,
    ee: ee$2,
    el: el$2,
    en: en$2,
    eo: eo$2,
    es: es$2,
    et: et$2,
    eu: eu$2,
    fa: fa$2,
    ff: ff$2,
    fi: fi$2,
    fil: fil$2,
    fo: fo$2,
    fr: fr$2,
    fur: fur$2,
    fy: fy$2,
    ga: ga$2,
    gd: gd$2,
    gl: gl$2,
    gsw: gsw$2,
    gu: gu$2,
    guw: guw$2,
    gv: gv$2,
    ha: ha$2,
    haw: haw$2,
    he: he$2,
    hi: hi$2,
    hr: hr$2,
    hsb: hsb$2,
    hu: hu$2,
    hy: hy$2,
    ia: ia$2,
    id: id$2,
    ig: ig$2,
    ii: ii$2,
    io: io$2,
    is: is$2,
    it: it$2,
    iu: iu$2,
    iw: iw$2,
    ja: ja$2,
    jbo: jbo$2,
    jgo: jgo$2,
    ji: ji$2,
    jmc: jmc$2,
    jv: jv$2,
    jw: jw$2,
    ka: ka$2,
    kab: kab$2,
    kaj: kaj$2,
    kcg: kcg$2,
    kde: kde$2,
    kea: kea$2,
    kk: kk$2,
    kkj: kkj$2,
    kl: kl$2,
    km: km$2,
    kn: kn$2,
    ko: ko$2,
    ks: ks$2,
    ksb: ksb$2,
    ksh: ksh$2,
    ku: ku$2,
    kw: kw$2,
    ky: ky$2,
    lag: lag$2,
    lb: lb$2,
    lg: lg$2,
    lkt: lkt$2,
    ln: ln$2,
    lo: lo$2,
    lt: lt$2,
    lv: lv$2,
    mas: mas$2,
    mg: mg$2,
    mgo: mgo$2,
    mk: mk$2,
    ml: ml$2,
    mn: mn$2,
    mo: mo$2,
    mr: mr$2,
    ms: ms$2,
    mt: mt$2,
    my: my$2,
    nah: nah$2,
    naq: naq$2,
    nb: nb$2,
    nd: nd$2,
    ne: ne$2,
    nl: nl$2,
    nn: nn$2,
    nnh: nnh$2,
    no: no$2,
    nqo: nqo$2,
    nr: nr$2,
    nso: nso$2,
    ny: ny$2,
    nyn: nyn$2,
    om: om$2,
    or: or$2,
    os: os$2,
    osa: osa$2,
    pa: pa$2,
    pap: pap$2,
    pl: pl$2,
    prg: prg$2,
    ps: ps$2,
    pt: pt$2,
    pt_PT: pt_PT$2,
    rm: rm$2,
    ro: ro$2,
    rof: rof$2,
    root: root$2,
    ru: ru$2,
    rwk: rwk$2,
    sah: sah$2,
    saq: saq$2,
    sc: sc$2,
    scn: scn$2,
    sd: sd$2,
    sdh: sdh$2,
    se: se$2,
    seh: seh$2,
    ses: ses$2,
    sg: sg$2,
    sh: sh$2,
    shi: shi$2,
    si: si$2,
    sk: sk$2,
    sl: sl$2,
    sma: sma$2,
    smi: smi$2,
    smj: smj$2,
    smn: smn$2,
    sms: sms$2,
    sn: sn$2,
    so: so$2,
    sq: sq$2,
    sr: sr$2,
    ss: ss$2,
    ssy: ssy$2,
    st: st$2,
    su: su$2,
    sv: sv$2,
    sw: sw$2,
    syr: syr$2,
    ta: ta$2,
    te: te$2,
    teo: teo$2,
    th: th$2,
    ti: ti$2,
    tig: tig$2,
    tk: tk$2,
    tl: tl$2,
    tn: tn$2,
    to: to$2,
    tr: tr$2,
    ts: ts$2,
    tzm: tzm$2,
    ug: ug$2,
    uk: uk$2,
    ur: ur$2,
    uz: uz$2,
    ve: ve$2,
    vi: vi$2,
    vo: vo$2,
    vun: vun$2,
    wa: wa$2,
    wae: wae$2,
    wo: wo$2,
    xh: xh$2,
    xog: xog$2,
    yi: yi$2,
    yo: yo$2,
    yue: yue$2,
    zh: zh$2,
    zu: zu$2
  });

  function normalize(locale) {
    if (typeof locale !== 'string' || locale.length < 2) throw new RangeError("Invalid language tag: ".concat(locale)); // The only locale for which anything but the primary subtag matters is
    // Portuguese as spoken in Portugal.

    if (locale.startsWith('pt-PT')) return 'pt-PT';
    var m = locale.match(/.+?(?=[-_])/);
    return m ? m[0] : locale;
  }

  function getPlural(locale) {
    if (typeof locale === 'function') {
      var _lc = normalize(locale.name);

      return {
        isDefault: false,
        id: safeIdentifier_1(_lc),
        lc: _lc,
        locale: locale.name,
        getPlural: locale,
        cardinals: locale.cardinals || [],
        ordinals: locale.ordinals || []
      };
    }

    var lc = normalize(locale);

    if (lc in Plurals) {
      return {
        isDefault: true,
        id: safeIdentifier_1(lc),
        lc: lc,
        locale: locale,
        getCardinal: Cardinals[lc],
        getPlural: Plurals[lc],
        cardinals: PluralCategories[lc].cardinal,
        ordinals: PluralCategories[lc].ordinal
      };
    }

    return null;
  }
  function getAllPlurals(firstLocale) {
    var keys = Object.keys(Plurals).filter(function (key) {
      return key !== firstLocale;
    });
    keys.unshift(firstLocale);
    return keys.map(getPlural);
  }
  function hasPlural(locale) {
    var lc = normalize(locale);
    return lc in Plurals;
  }

  var MessageFormat = /*#__PURE__*/function () {
    _createClass(MessageFormat, null, [{
      key: "escape",

      /**
       * Used by the constructor when no `locale` argument is given.
       *
       * @memberof MessageFormat
       * @default 'en'
       */

      /**
       * Escape special characaters by surrounding the characters `{` and `}` in the
       * input string with 'quotes'. This will allow those characters to not be
       * considered as MessageFormat control characters.
       *
       * @memberof MessageFormat
       * @param {string} str - The input string
       * @param {boolean} [octothorpe=false] - Also escape `#`
       * @returns {string} The escaped string
       */
      value: function escape(str, octothorpe) {
        var esc = octothorpe ? /[#{}]/g : /[{}]/g;
        return String(str).replace(esc, "'$&'");
      }
      /**
       * Returns a subset of `locales` consisting of those for which MessageFormat
       * has built-in plural category support.
       *
       * @memberof MessageFormat
       * @param {(string|string[])} locales
       * @returns {string[]}
       */

    }, {
      key: "supportedLocalesOf",
      value: function supportedLocalesOf(locales) {
        var la = Array.isArray(locales) ? locales : [locales];
        return la.filter(hasPlural);
      }
      /**
       * @typedef {Object} MessageFormat~Options - The shape of the options object
       *   that may be used as the second argument of the constructor.
       * @property {boolean} [biDiSupport=false] - Add Unicode control characters to
       *   all input parts to preserve the integrity of the output when mixing LTR
       *   and RTL text
       * @property {string} [currency='USD'] - The currency to use when formatting
       *   `{V, number, currency}`
       * @property {Object} [customFormatters] - Map of custom formatting functions
       *   to include. See the {@tutorial guide} for more details.
       * @property {boolean} [requireAllArguments=false] - Require all message
       *   arguments to be set with a defined value
       * @property {('string'|'values')} [returnType='string'] - Return type of
       *   compiled functions; either a concatenated string or an array (possibly
       *   hierarchical) of values
       * @property {boolean} [strictNumberSign=false] - Allow `#` only directly
       *   within a plural or selectordinal case, rather than in any inner select
       *   case as well.
       */

      /**
       * Create a new MessageFormat compiler
       *
       * ```
       * import MessageFormat from 'messageformat'
       * ```
       *
       * @class MessageFormat
       * @classdesc MessageFormat-to-JavaScript compiler
       * @param {string|Array} [locale]
       *   Define the locale or locales supported by this MessageFormat instance. If
       *   given multiple valid locales, the first will be the default. If `locale`
       *   is empty, it will fall back to `MessageFormat.defaultLocale`.
       *
       *   String `locale` values will be matched to plural categorisation functions
       *   provided by the Unicode CLDR. If defining your own instead, use named
       *   functions instead, optionally providing them with the properties:
       *   `cardinals: string[]`, `ordinals: string[]`, `module: string` (to import
       *   the formatter as a runtime dependency, rather than inlining its source).
       *
       *   If `locale` has the special value `'*'`, it will match *all* available
       *   locales. This may be useful if you want your messages to be completely
       *   determined by your data, but may provide surprising results if your input
       *   message object includes any 2-3 character keys that are not locale
       *   identifiers.
       * @param {MessageFormat~Options} [options] - Compiler options
       */

    }]);

    function MessageFormat(locale, options) {
      _classCallCheck(this, MessageFormat);

      this.options = Object.assign({
        biDiSupport: false,
        currency: 'USD',
        customFormatters: {},
        returnType: 'string',
        strictNumberSign: false
      }, options);

      if (locale === '*') {
        this.plurals = getAllPlurals(MessageFormat.defaultLocale);
      } else if (Array.isArray(locale)) {
        this.plurals = locale.map(getPlural).filter(Boolean);
      } else if (locale) {
        var pl = getPlural(locale);
        if (pl) this.plurals = [pl];
      }

      if (!this.plurals || this.plurals.length === 0) {
        var _pl = getPlural(MessageFormat.defaultLocale);

        this.plurals = [_pl];
      }
    }
    /**
     * @typedef {Object} MessageFormat~ResolvedOptions
     * @property {boolean} biDiSupport - Whether Unicode control characters be
     *   added to all input parts to preserve the integrity of the output when
     *   mixing LTR and RTL text
     * @property {object} customFormatters - Map of custom formatting functions
     * @property {string} locale - The default locale
     * @property {object[]} plurals - All of the supported plurals
     * @property {boolean} strictNumberSign - Is `#` only allowed directly within
     *   a plural or selectordinal case
     */

    /**
     * Returns a new object with properties reflecting the default locale,
     * plurals, and other options computed during initialization.
     *
     * @memberof MessageFormat
     * @instance
     * @returns {MessageFormat~ResolvedOptions}
     */


    _createClass(MessageFormat, [{
      key: "resolvedOptions",
      value: function resolvedOptions() {
        return _objectSpread2({}, this.options, {
          locale: this.plurals[0].locale,
          plurals: this.plurals
        });
      }
      /**
       * Compile a message into a function
       *
       * Given a string `message` with ICU MessageFormat declarations, the result is
       * a function taking a single Object parameter representing each of the
       * input's defined variables, using the first valid locale.
       *
       * @memberof MessageFormat
       * @instance
       * @param {string} message - The input message to be compiled, in ICU MessageFormat
       * @returns {function} - The compiled function
       *
       * @example
       * const mf = new MessageFormat('en')
       * const msg = mf.compile('A {TYPE} example.')
       *
       * msg({ TYPE: 'simple' })  // 'A simple example.'
       */

    }, {
      key: "compile",
      value: function compile(message) {
        var compiler = new Compiler(this.options);
        var fnBody = 'return ' + compiler.compile(message, this.plurals[0]);
        var nfArgs = [];
        var fnArgs = [];

        for (var _i = 0, _Object$entries = Object.entries(compiler.runtime); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              fmt = _Object$entries$_i[1];

          nfArgs.push(key);
          fnArgs.push(fmt);
        }

        var fn = _construct(Function, nfArgs.concat([fnBody]));

        return fn.apply(null, fnArgs);
      }
    }]);

    return MessageFormat;
  }();

  MessageFormat.defaultLocale = 'en';

  return MessageFormat;

})));
